import { isChrome as chrome, isSafari as safari, isMobileOnly as mobileOnly,isTablet as tablet, isAndroid as android, isIOS as ios,isFirefox as is_ffox, isIE as ie,isEdge as edge, osName as osname, fullBrowserVersion as fbrowserversion, mobileVendor as mobvendor, deviceType, isIPad13 as ipad13} from "react-device-detect";
import Const from "../constants/Constants";
import Util from "./Util";
import SessionDataStore from "./SessionDataStoreController";
import RTM from "./RTM";
import RTMConst from "../constants/Rtmconstants";
import hostlanguage from '../services/contentData';
import ParticipantCollection from "./ParticipantCollection";
import ParticipantModel from "./model/ParticipantModel";
import ParticipantView from "./view/participant/ParticipantView";
import axios from "axios";
import { updateHeartRate } from '../utils/updateHeartRate';
import { loadWhiteboard } from '../utils/whiteboard';
import { updatesse } from '../utils/updatesse';
import whiteboard from "../utils/whiteboardNew";
//import {debounce} from "underscore";

function StreamingController(){ 
	var $ = window.$ || {};
	var AgoraRTM = window.AgoraRTM;
	var AgoraRTC = window.AgoraElectron ? window.AgoraElectron : window.AgoraRTC;
	var client = AgoraRTC.createClient({mode: 'live', codec:'vp8'});
	var localStream;
	var sep = '~@$';
	var retryCounter = 0;
	var currentUserData = JSON.parse(localStorage.getItem("userData"));
	var sessionDataStore = SessionDataStore.getInstance();
	var previousDeviceVolume = 255;
	var rtcJoinChannelInitialized = false;
	var rtm = RTM.getInstance();
	var collection = new ParticipantCollection();
	var mutedOtherParticipants = false;
	var hostStreamMuted = false;
	var isOnline = true;
	var newclient = window.newclient; 
	var channel = window.channel;
	var rtmAppId = currentUserData.rtmAppId;
	var rtmChannelId = currentUserData.sessionData.rtmChannelId;
	var token = null;
	var peer = currentUserData.email;
	var dualStreamEnabled = false;
	var mainCameraId;
	var mainMicId;
	window['main_mic_id_gue'] = null;
	window['streamSwapped'] = false;
	var streamArray = [];
	window['streamArray'] = streamArray;
	var streamPublished = false;
	var zoomedOption = 1;
	window['zoomedOption'] = 0;
	var rtmRetryCounter = 0;
	var localStats = [];
	var userHeartRate = null;
	var localStatsTimer = 5000,               // timer every 5 sec to get local stats
    streamSetToLow = false,               // flag to check remote streams has been set to low or not
    previousNetworkQuality = 6,  
	networkQualityArray = [],	// Previous Network Test Quality, allows to reduce processing by only performing functions if it changes
    switchUserTimeout = 5000,
	isMutedByMe = false;
	window['isMutedByMe'] = false;
	window['guestUser'] = true;
	window['gridOn'] = false;
	window['canvasOn'] = false;
	window['repCounting'] = 0;
	window['scriptStarted'] = false;
	window['tablete'] = tablet;
	window['pauseBeforeEquipmentInjected'] = false;
	var activityArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	var currentActivity = {};
	window['globalCurrentIndex'] = 0;
	var usersOnScreen = [];
	var usersOnScreenCurrent = [];
	var indexToHide = 0;
	var drawSplitArray = {};
	var emojiNotification = new Audio('./audio/emoji_notify.wav');
	var cameraIndex = -1;
	var isCameraRequired = JSON.parse(localStorage.getItem('userData')).sessionData.isCameraRequired;
	var notification = new Audio('./audio/notify.mp3');
	var cameraKeyNum;
	window['openParticipantList'] = false;
	window['partZoomedIn'] = false;
	var shareAllUser = 0;
	var currentSharedUser = 0;
	var streamClosedNetworkIssue = false;
	if ( !window['userWhiteboard'] ) { window['userWhiteboard'] = {}; }
	window['virtualScriptStarted'] = false;
	window['clickedOnLogout'] = false;
	var participantsInStream = [];
	var userCounter2 = 0;
	var userCounter = 0;
	if ( !window['electron'] && parseInt(currentUserData.default.setCloudProxy) === 1 )
		{
			client.startProxyServer(3);
		}
		
	if ( window['electron'] )
		{
			window['deviceNotSupported'+currentUserData.id] = false;
		}
	else
		{	
			window['deviceNotSupported'+currentUserData.id] = true;
		}
		
	if ( window['switchStreamsInterval'] ) { clearInterval(window['switchStreamsInterval']); window['switchStreamsInterval'] = null; }
		
	iterateParticipants();
	
	var remoteEvent = '';
	var emojiesIndex = 0;
	var emojieIds = ['Like', 'Meh', 'Easy', 'Ouch', 'Beast', 'Cool'];
	var microphoneIndex = 0;
	var microphoneIds = [];
	var cameraIndexR = 0;
	var cameraIds = [];
	
	var lastScriptCode = 0;
	var hostZoneSet = false;
	var nextActivityStartTimeout = 0;
	
	if ( !currentUserData.whiteboardValues )
		{
			$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": currentUserData.token},
			  url: Const.BASE_API_PATH +'/api/v1/session/whiteboardValues',
			  type: 'post',
			  dataType: 'json',
			  success: function( data, textStatus, jQxhr ) {
				  if ( data.responseData )
					{
						currentUserData.whiteboardValues = data.responseData;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
						window.currentUserData = currentUserData;
					}
			}});
		}
		
	if ( !window['boxJumpSize'] && window['hasBoxJump'] )
		{
			let boxJumpData = {
				'userId': currentUserData.id,
				'equipmentStatement': 'hostInfo',
				'value': ''
			};
			
			$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": currentUserData.token},
			  url: Const.BASE_API_PATH +'/api/v1/user/getBoxingPosition',
			  type: 'post',
			  dataType: 'json',
			  data: JSON.stringify(boxJumpData),
			  success: function( data, textStatus, jQxhr ) {
				  if ( data.responseData )
					{
						var setBagPositions = data.responseData;
						var setBagPosition = setBagPositions['boxJumpSize'] ? setBagPositions['boxJumpSize'] : '';
						console.log(setBagPosition, 'setBagPosition');
						window['boxJumpSize'] = setBagPosition;
						
						if ( setBagPosition == '7x7' ) { window['boxJumpHeight'] = 49; window['boxJumpWidth'] = 49; }
						if ( setBagPosition == '10x10' ) { window['boxJumpHeight'] = 70; window['boxJumpWidth'] = 70; }
						if ( setBagPosition == '12x12' ) { window['boxJumpHeight'] = 84; window['boxJumpWidth'] = 84; }
						if ( setBagPosition == '14x14' ) { window['boxJumpHeight'] = 98; window['boxJumpWidth'] = 98; }
						if ( setBagPosition == '16x16' ) { window['boxJumpHeight'] = 112; window['boxJumpWidth'] = 112; }
					}
			}});
		}
	
	if ( currentUserData.sessionData.isHiddenRaiseHand && currentUserData.sessionData.isHiddenRaiseHand == 1 )
		{
			$('#raise_hand').addClass('d-none');
		}
		
	if ( currentUserData.sessionData.isHostOffline && currentUserData.sessionData.isHostOffline == 1 )
		{
			$('#onlineicon').addClass('d-none');
			$('#onlinetext').text('OFFLINE');
			$('#offlineicon').removeClass('d-none');
			$('#hostNoVideo').removeClass('d-none');
		}
		
	window.remoteVideoStates = (uid, state, reason, elapsed) => {}
	window.networkQualityStats = (uid, downlinkQuality) => {}
		
	function rtcJoin(syncScript = true) {
		//console.log('rtcJoin');
		let camera = null;
		let microphone = null;
		let mediaIds = localStorage.getItem("media-setting");
		
		if ( mediaIds != undefined ) 
			{
				mediaIds = JSON.parse(mediaIds);
				if ( mediaIds.camera != null && mediaIds.microphone != null )
					{
						camera = mediaIds.camera;
						mainMicId = mediaIds.microphone;
						microphone = mediaIds.microphone;
						window['main_mic_id_gue'] = mediaIds.microphone;
					}
				else
					{
						if ( isCameraRequired == 1 )
							{
								return false;
							}
					}
			}
	
		var channel_key = currentUserData.sessionData.streamToken != undefined ? currentUserData.sessionData.streamToken : null;
		
		if ( !window['electron'] ) 
			{
				AgoraRTC.Logger.enableLogUpload();
				AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.INFO);
			}
		
		console.log("currentUserData---", currentUserData);
			
		client.init(currentUserData.sessionData.appId, function () {
			var channelName = currentUserData.sessionData.channelId;
			
			if ( window['electron'] )
				{
					client.setClientRole(1);
					if( parseInt(currentUserData.default.enableAudioProfile) === 1 ) 
						{ 
							let audioProfileNative = currentUserData.default.setAudioProfileParticipantNative.split(',');
							client.setAudioProfile(audioProfileNative);
						}
				}
				
			client.setEncryptionMode(process.env.REACT_APP_ENC_MODE);
			client.setEncryptionSecret(process.env.REACT_APP_ENC_SECRET);
			
			initLocalStream();
			
			function initLocalStream(){
				if ( camera && camera != '' && camera.length > 0 && localStorage.getItem('cameraAccessAllowed') == "true" ) 
					{
						localStream = AgoraRTC.createStream({streamID: currentUserData.id, audio: true, cameraId: camera, microphoneId: microphone, video: true, screen: false, audioProcessing: {AEC: true, AGC: true, ANS: true} });
					} 
				else 
					{
						localStream = AgoraRTC.createStream({streamID: currentUserData.id, audio: true, cameraId: camera, microphoneId: microphone, video: false, screen: false, audioProcessing: {AEC: true, AGC: true, ANS: true} });
					}
				
				if ( window.setUserProfile ) { window.setUserProfile(localStorage.getItem("video-resolution")); }
				
				if ( currentUserData.default.dualStreamParticipant ) { enableDualStream(); }
				
				localStream.on("player-status-change", function(evt){
					if ( !rtcJoinChannelInitialized )
						{
							rtcJoinChannelInitialized = true;
							initJoinChannel();
						}						 
				});
				
				localStream.init(function() {
					localStream.play('mystream');
					if ( localStorage.getItem('turnOfCamera') )
						{
							let cameraDisableStatus = JSON.parse(localStorage.getItem('turnOfCamera'));
							
							for ( var i = 0; i<cameraDisableStatus.length; i++ )
								{
									if ( cameraDisableStatus[i] == 'Me (I dont\'t want to see myself)' ) 
										{
											localStream.stop();
										}
								}
								
							if ( window['electron'] && cameraDisableStatus.length == 3 )
								{
									window['globalAgora'].agora.enableLocalVideo(false);
									rtm.invoke({'code': 53});
								}
						}
					
					getLocalStats();
					
					window['mainLocalStream'] = localStream;
					if ( window['electron'] )
						{
							let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
							mediaIds = JSON.parse(mediaIds);
							
							window['mainLocalStream'].on("audioDeviceStateChanged", function(deviceId, deviceType, deviceState) {
								if ( deviceType == 1 && ( deviceState == 1 || deviceState == 4 || deviceState == 8 ) )
									{
										if ( deviceState == 1 )
											{
												mediaIds['microphone'] = deviceId;
												mediaIds['speaker'] = '';
												localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
												
												setTimeout(() => {
													getDevices( () => {                             
													  swithMicAndSpeaker();
													});
												}, 1000);
											}
									}
								else if ( ( deviceState == 4 || deviceState == 8 ) && deviceId == mediaIds['microphone'] )
									{
										mediaIds['microphone'] = '';
										mediaIds['speaker'] = '';
										localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));

										setTimeout(() => {
											getDevices( () => {                             
											  swithMicAndSpeaker();
											});
										}, 1000);
									}
							});
							
							window['mainLocalStream'].on("videoDeviceStateChanged", function(deviceId, deviceType, deviceState) {
								if ( deviceState == 8 )
									{
										if ( deviceId == mediaIds['camera'] ) 
											{
												mediaIds['camera'] = '';
												localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
												getDevices( () => { });
											}
									}
							});
							
							window['mainLocalStream'].on("audioDeviceVolumeChanged", function(deviceType, volume, muted) {
								if ( deviceType == 1 )
									{
										if ( volume == 165 )
											{
												window['globalAgora'].agora.setAudioRecordingVolume(previousDeviceVolume);
											}
										else
											{
												window['globalAgora'].agora.setAudioRecordingVolume(volume);
												previousDeviceVolume = volume;
											}
									}
							});
						}
						
					updateSessionJoinedStatus();
					
					if ( currentUserData.sessionData.scriptDetail !== undefined && currentUserData.sessionData.scriptDetail.length > 0 && syncScript ) 
						{
							setTimeout(()=>{
								let message = RTMConst.SYNC_SCRIPT+sep;
								sendMessage(currentUserData.sessionData.hostEmail, message);

								let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.sessionData.hostId, "message": RTMConst.SYNC_SCRIPT, "details": JSON.stringify({"action":"sync", "type":"script"}), "timestamp": Util.getCurrentTimestamp()};
								sessionDataStore.addSessionData(addObject);
							}, 2000);
						}
						
					if ( window.electron )
						{
							initJoinChannel();
						}
					
				}, function (err) {
					initJoinChannel();
					let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "deviceAccess", "msg": err.msg + ' | ' + err.info}), "timestamp": Util.getCurrentTimestamp()};
					sessionDataStore.addSessionData(addObject);
				});
				function initJoinChannel() {
					client.join(channel_key, channelName.toString(), currentUserData.id, function(uid) {
						publish();
						let cameraDisableStatus = [];
						if ( localStorage.getItem('turnOfCamera') )
							{
								cameraDisableStatus = JSON.parse(localStorage.getItem('turnOfCamera'));
								
								if ( cameraDisableStatus.indexOf("My Instructor (Trainer)") > -1 ) 
									{ 
										switchVideoBroadcastingHost(0, true);
									}
								else
									{
										switchVideoBroadcastingHost(1, true);
									}
								if ( cameraDisableStatus.indexOf("Other Members") > -1 ) 
									{ 
										switchVideoBroadcasting(0, true);
									}
								else
									{
										switchVideoBroadcasting(1, true);
									}
							}
						else
							{
								informVideoBroadcasting(1, true); 
							}
					}, function(err) {
						  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "rtcJoin", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
						  sessionDataStore.addSessionData(addObject);
						  if (err == 'SOCKET_ERROR') { initJoinChannel(); }
					});
				}
				
				var channelKey = "";
				client.on('error', function(err) {
					if ( err.reason === 'DYNAMIC_KEY_TIMEOUT' )
						{
							client.renewChannelKey(channelKey, function(){ }, function(err){ }); 
						}
						
					if ( err.reason === 'REQUEST_ABORT' && isOnline === true )
						{
							leave();
							rtcJoinChannelInitialized = false;
							rtcJoin(); 
						}
				});
				
				rtcCallbacks();
				
				client.on("connection-state-change", function(evt) {
					//console.log('###connection-state-change===', evt.prevState, evt.curState, evt);
				});
			}
			
		}, function (err) {
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "rtcInitialize", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		});
	}
	
	function newParticipantJoined(publisherId) {
		let userDetails = collection.getDetailsById(publisherId);
		if( !userDetails ) { return false; }
		incrementcountAtAttendies(userDetails, 'Joined');
		//console.log('newParticipantJoined');
		//console.log(userDetails);
		if ( userDetails && userDetails.userType == Const.USER_TYPE.PARTICIPANT )
			{
				if ( userDetails.broadcastVideo === false )
					{
						$('#nocam'+userDetails.id).removeClass('d-none');
						$('#participant_stream'+userDetails.id).addClass('d-none');
					}
				else
					{
						if ( userDetails.id !== currentSharedUser )
							{
								$('#nocam'+userDetails.id).addClass('d-none');
								$('#participant_stream'+userDetails.id).removeClass('d-none');
							}
					}
			}
	}
	
	function updateSessionJoinedStatus() {
		  $.ajax({
			  headers: { 
				  "Content-Type": "application/json; charset=utf-8",
				  "Authorization": currentUserData.token
			  },
			  url: Const.BASE_API_PATH+'/api/v1/session/'+currentUserData.sessionData.id+'/joinstatus',
			  dataType: 'json',
			  type: 'PUT',
			  success: function( data, textStatus, jQxhr ){
				  //console.log(data);
			  },
			  error: function( jqXhr, textStatus, errorThrown ){
				  //console.log( errorThrown );
			  }
		  });

		  return false;
	  }
	
	function rtcCallbacks() {
		client.on("peer-online", function (evt) {
			//console.log('rtcCallbacks peer-online');
			if(evt.uid != Const.STREAM_INJECT_UID) {
				let updateObject = {"isAvailableAtRTC": true};
				collection.updateModel(evt.uid, JSON.stringify(updateObject));
              
				newParticipantJoined(evt.uid);
			}
		});
		
		client.on('stream-added', function (evt) {
			//console.log('rtcCallbacks stream-added');
			var stream = evt.stream;
			if ( stream.getId() == Const.STREAM_INJECT_UID )
				{
					client.subscribe(stream, function (err) { });
				}
			else
				{
					var userDetails = collection.getDetailsById(stream.getId());
					//console.log('userDetails');
					//console.log(userDetails);
					if( !userDetails ) { return false; }
					if ( userDetails.userType == Const.USER_TYPE.HOST )
						{
							client.subscribe(stream, function (err) { });
						}
					else
						{
							if ( currentUserData.sessionData.showOtherParticipants == 1 ) 
								{
									if ( mutedOtherParticipants === false && (userDetails.broadcastVideo === null || userDetails.broadcastVideo === true) )
										{
											let broadcasterCount = collection.getBroadcasterCount();
											if ( broadcasterCount < currentUserData.default.participantMaxUserLimit )
												{
													client.subscribe(stream, function (err) { });
												}
											else
												{
													if ( safari )
														{
															client.subscribe(stream, function (err) { });
														}
													else
														{
															client.subscribe(stream, {video: false, audio: true});
														}
												}
										}
									else
										{
											if ( safari )
												{
													client.subscribe(stream, function (err) { });
												}
											else
												{
													client.subscribe(stream, {video: false, audio: true});
												}
										}
								}
							else
								{
									if ( safari )
										{
											client.subscribe(stream, function (err) { });
										}
									else
										{
											client.subscribe(stream, {video: false, audio: true});
										}
										
									 mutedOtherParticipants = true;
								}
						}
				}
		});
		
		client.on('stream-subscribed', function (evt) {
			//console.log('rtcCallbacks stream-subscribed');
			let stream = evt.stream;
			newParticipantStreamSubscribed(stream);
		});
		
		client.on('stream-removed', function (evt) {
			//console.log('stream-removed---', stream.getId());
			
			var stream = evt.stream;
			stream.stop();
			
			if ( stream.getId() !== undefined )
				{
					if ( stream.getId() == currentUserData.sessionData.hostId )
						{
							setHostOffline();
						}
					else
						{
							$('#participant_stream_content'+stream.getId()).remove();
							checkForInterval(stream.getId());
						}
				}
		});
		
		client.on('peer-leave', function (evt) {
			//console.log('peer-leave---', evt);
			var stream = evt.stream;
			
			if ( evt.uid == currentUserData.sessionData.hostId && window['streamSwapped'] ) { swapStreamVirtual(true); }
			
			removeStreamFromArray(evt.uid);
			checkForInterval(evt.uid);
			
			if ( evt.uid !== currentUserData.sessionData.hostId ) 
				{
					$('#participant_stream_content'+evt.uid).remove();
				}
			else
				{
					setHostOffline();
				}
			
			countParticipants();
			
			if ( evt.uid == currentUserData.sessionData.hostId )
				{
					window['hostInStreaming'] = false;
				}
			
			if ( stream )
				{
					if ( currentUserData.sessionData.switchHostParticipant != undefined && currentUserData.sessionData.switchHostParticipant == 1 && stream.getId() == currentUserData.sessionData.hostId )
						{
							if ( !window['streamSwapped'] ) { swapStreamVirtual(false, true); } 
						}
						
					stream.stop();
					
					if ( stream.getId() !== currentUserData.sessionData.hostId ) 
						{
							$('#participant_stream_content'+stream.getId()).remove();
							checkForInterval(stream.getId());
						}
					else
						{
							setHostOffline();
						}
				}
			else if ( window['electron'] )
				{
					if ( currentUserData.sessionData.switchHostParticipant != undefined && currentUserData.sessionData.switchHostParticipant == 1 && evt.uid == currentUserData.sessionData.hostId )
						{
							if ( !window['streamSwapped'] ) { swapStreamVirtual(false, true); } 
						}
						
					if ( evt.uid !== currentUserData.sessionData.hostId ) { checkForInterval(evt.uid); }
				}
				
			let updateObject = {"isAvailableAtRTC": false};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));
			
			let userDetails = collection.getDetailsById(evt.uid);
			if( !userDetails ) { return false; }
			
			if ( Const.USER_TYPE.HOST == userDetails.userType ) 
				{
					setHostOffline();
				}
		});
		
		client.on('mute-audio', function (evt) {
			let updateObject = {"audioMuted": true};
			collection.updateModel(evt.uid, JSON.stringify(updateObject)); 
		});
		
		client.on('unmute-audio', function (evt) {
			let updateObject = {"audioMuted": false};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));
		});
		
		client.on('mute-video', function (evt) {
			let updateObject = {"isVisible": false, "videoMuted": true};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));
		});
		
		client.on('unmute-video', function (evt) {
			let updateObject = {"videoMuted": false};
			collection.updateModel(evt.uid, JSON.stringify(updateObject));
		});
		
		client.on('first-video-frame-decode',function(evt){
			if ( evt.stream.streamId !== currentSharedUser )
				{
					$('#nocam'+evt.stream.streamId).addClass('d-none');
					$('#participant_stream'+evt.stream.streamId).removeClass('d-none');
				}
			
			if ( hostStreamMuted === true )
				{
					evt.stream.muteAudio();
				}
			else
				{
					evt.stream.unmuteAudio();
				}
		});
	}
	
	function removeStreamFromArray(streamId) {
      let streamsLength = streamArray.length;

      if (streamsLength > 0) {
          for (let i = 0; i < streamsLength; i++) {
              if (streamArray[i] != undefined && streamArray[i].getId() != undefined && streamId == streamArray[i].getId()) {
					streamArray.splice(i, 1);  
              }
          }
      }
	}
	
	function newParticipantStreamSubscribed(stream) {
		if ( currentUserData.sessionData.ondemandId > 0 ) { return false; }
		if ( stream.getId() == Const.STREAM_INJECT_UID )
			{
				/* stream.play('agora_remote_injected_vdo' + stream.getId(), function(errState){
					if (errState && errState.status !== "aborted"){
						stream.resume();
					}
				}); */
			}
		else
			{
				var userDetails = collection.getDetailsById(stream.getId());
				if( !userDetails ) { return false; }
				
				removeStreamFromArray(userDetails.id);
				let subscribeToAudio = false;
				
				if ( Const.USER_TYPE.HOST == userDetails.userType )
					{
						$('#hostNoVideo').addClass('d-none');
						stream.play('host_stream', function(errState){
							if (errState && errState.status !== "aborted")
								{
									stream.resume();
								}
						});
						
						if ( hostStreamMuted === true ) 
							{
								stream.muteAudio();
							}
						
						/* if ( window['hideMemberFitnessScript'] )
							{
								window['hideMemberFitnessScript']();
							} */
						
						$('#onlinetext').text('ONLINE');
						$('#onlineicon').removeClass('d-none');
						$('#offlineicon').addClass('d-none');
						checkForMicCamPermission();
						
						currentUserData.sessionData.isHostOffline = 0;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
							
						streamArray.push(stream);
						
						if ( currentUserData.sessionData.switchHostParticipant != undefined && currentUserData.sessionData.switchHostParticipant == 1 )
							{
								if ( !window['streamSwapped'] ) { swapStreamVirtual(false, true, true, 'pip'); /*swapStreamVirtual(false, true); */} 
							}
						window['hostInStreaming'] = true;
					}
				else
					{
						$('#disable_streams').addClass('d-none');
						if ( window['checkForStreams'] )
							{
								window['checkForStreams']();
							}
						var intervalSeconds = 1000 * parseInt(currentUserData.default.participantSwitchDuration);
						var classHidden = '';
						var maxOnScreen = parseInt(currentUserData.default.participantMaxUserLimit);
						var currentOnScreen = 0;
						if ( $('#participant_streams .cam_container').length ) { currentOnScreen = $('#participant_streams .cam_container').length; }
						if ( currentOnScreen >= maxOnScreen ) { classHidden = 'd-none'; }
						
						var elementExists = document.getElementById("participant_stream_content"+userDetails.id);
						if ( typeof(elementExists) == 'undefined' || elementExists == null )
							{
								var firstLetter = userDetails.firstName.substring(0, 1).toUpperCase();
								var lastLetter = userDetails.lastName.substring(0, 1).toUpperCase();
								
								var participantStream = `<div class="cam_container cam_live_container ${classHidden}" key-id=${userDetails.id} id="participant_stream_content${userDetails.id}">
															<div class="cam_stream" id="participant_stream${userDetails.id}">
																<div class="participant_name_container">
																	<div class="participant_name">${userDetails.firstName}</div>
																</div>
															</div>
															<div class="no_cam_stream d-none" id="nocam${userDetails.id}">
																<div class="initials">${firstLetter}${lastLetter}</div>
																<div class="participant_name_container">
																	<div class="participant_name">${userDetails.firstName}</div>
																</div>
																<div class="abs_camoff" id="">
																	<div class="control_icon video_icon_participants">
																		<div class="muted_audio"></div>
																	</div>
																</div>
															</div>
															<div class="no_cam_stream d-none" id="shareAllScreen${userDetails.id}">
																<div class="initials">${firstLetter}${lastLetter}</div>
																<div class="participant_name_container">
																	<div class="participant_name">${userDetails.firstName}</div>
																</div>
															</div>
														</div>`;
													
								$('#participant_streams').append(participantStream);
								
								if ( window['checkShowUsers'] )
									{
										window['checkShowUsers']();
									}
									
								if ( userDetails.broadcastVideo == false )
									{
										$('#participant_stream'+userDetails.id).addClass('d-none');
										$('#nocam'+userDetails.id).removeClass('d-none');
									}
								if ( classHidden != '' )
									{
										subscribeToAudio = true;
									}
								else
									{
										if ( currentUserData.sessionData.showOtherParticipants == 0 || !window['openParticipantList'] )
											{
												subscribeToAudio = true;
											}
										usersOnScreen.push(userDetails.id);
										usersOnScreenCurrent.push(userDetails.id);
									}	
							}
						else
							{
								if ( userDetails.broadcastVideo == false )
									{
										$('#participant_stream'+userDetails.id).addClass('d-none');
										$('#nocam'+userDetails.id).removeClass('d-none');
									}
								else
									{
										if ( userDetails.id !== currentSharedUser )
											{	
												$('#participant_stream'+userDetails.id).removeClass('d-none');
												$('#nocam'+userDetails.id).addClass('d-none');
											}
									}
							}
						
						setParticipantResolutionToLow(stream);
						
						stream.play('participant_stream'+userDetails.id, function(errState){
							if (errState && errState.status !== "aborted"){
								stream.resume();
							}
						});
						
						if ( hostStreamMuted === true )
							{
								stream.muteAudio();
							}
							
						streamArray.push(stream);
						if ( subscribeToAudio ) 
							{
								subscribeToAudioOnlyStream(userDetails.id);
							}
							
						if ( currentUserData.sessionData.showOtherParticipants == 1 ) {
							hideControls(userDetails.id);
						}	
						if ( currentOnScreen >= maxOnScreen )
							{
								if ( window['switchStreamsInterval'] ) 
								{ 
									countParticipants();
									return false; 
								}
								window['switchStreamsInterval'] = setInterval(function(){
									if ( window['openParticipantList'] )
										{
											var idToDelete = JSON.parse(JSON.stringify(usersOnScreenCurrent[0]));
										
											var foundToShow = false;
											for ( let y = 0; y < streamArray.length; y++ )
												{
													if ( streamArray[y] )
														{
															let streamId = streamArray[y].getId();
															if ( streamId != undefined && usersOnScreen.indexOf(streamId) == -1 && !foundToShow && streamId != currentUserData.sessionData.hostId && streamId != idToDelete )
																{
																	console.log('HIDE USER FROM LIST---', idToDelete);
																	subscribeToAudioOnlyStream(idToDelete);
																	$('#participant_stream_content'+idToDelete).addClass('d-none');
																	usersOnScreenCurrent.splice(0, 1);
																	
																	var userDetailsStream = collection.getDetailsById(streamId);
																	if ( userDetailsStream && userDetailsStream.broadcastVideo !== false )
																		{
																			subscribeToVideoStream(streamId);
																		}
																	
																	console.log('SHOW USER ON LIST---', streamId);
																	usersOnScreen.push(streamId);
																	usersOnScreenCurrent.push(streamId);
																	$('#participant_stream_content'+streamId).removeClass('d-none');
																	
																	if ( usersOnScreen.length >= (streamArray.length-1) ) 
																		{
																			usersOnScreen = JSON.parse(JSON.stringify(usersOnScreenCurrent));
																		} 	
																		
																	var visibleLength = usersOnScreenCurrent.length;
																	if ( visibleLength => maxOnScreen ) { foundToShow = true; }
																}
														}
												}
										}
								}, intervalSeconds);  
							}
						else
							{
								if ( window['switchStreamsInterval'] ) { clearInterval(window['switchStreamsInterval']); window['switchStreamsInterval'] = null; }
							}
					}
					
				countParticipants();
			}
	}
	
	function countParticipants()
		{
			if ( currentUserData.sessionData.ondemandId > 0 ) { return false; }
			var userData;
			participantsInStream = [];
			for (let i=0; i<streamArray.length; i++)
				{
					if ( streamArray[i] )
						{
							if ( streamArray[i]['streamId'] != currentUserData.sessionData.hostId )
								{
									userData = collection.getDetailsById(streamArray[i]['streamId']);
									//var userCounter = 0;
									//if ( $('#score'+userData.id) && $('#score'+userData.id).html() ) { userCounter = $('#score'+userData.id).html(); }
									let userObject = {
											firstName: userData.firstName,
											lastName: userData.lastName,
											image: userData.image,
											userId: userData.id,
											counter: userCounter
										};
									participantsInStream.push(userObject);
								}
						}
				}
			
			if ( participantsInStream.length > 0 )
				{
					let count = participantsInStream.length;
						$('#joined_users_at_client').text('('+count+')');
						$('#joined_users_at_client').removeClass('d-none');
						$('#joined_users_at_client1').text('('+count+')');
						$('#joined_users_at_client1').removeClass('d-none');
				}
			else
				{
					$("#joined_users_at_client").addClass('d-none');
					$("#joined_users_at_client1").addClass('d-none');
					
					window['showHideStream']();
					$('#disable_streams').removeClass('d-none');
				}
				
			userData = collection.getDetailsById(currentUserData.id);
			userCounter2 = window['counterAll'];
			//if ( $('#score'+userData.id) && $('#score'+userData.id).html() ) { userCounter2 = $('#score'+userData.id).html(); }
			console.log('userData-----',userData);
			let userObject2 = {
									firstName: userData.firstName,
									lastName: userData.lastName,
									image: userData.image,
									userId: userData.id,
									counter: userCounter2
								};
			participantsInStream.push(userObject2);
			if ( participantsInStream.length > 0 )
				{
					$('#participants_counter').text(participantsInStream.length);
					$('#participants_counter').removeClass('d-none');
				}
			else
				{
					$('#participants_counter').addClass('d-none');
				}
			
			window['updateLiveParticipants'](participantsInStream);
		}
	
	function checkForInterval(streamId){
		//console.log('checkForInterval streamId---', streamId);
		if ( !streamId ) { return false; }
		
		var maxOnScreen = currentUserData.default.participantMaxUserLimit;
		//console.log('userLeft');
		//console.log(streamId);
		var indexOfScreenCurrent = usersOnScreenCurrent.indexOf(streamId);
		if ( indexOfScreenCurrent > -1 ) { usersOnScreenCurrent.splice(indexOfScreenCurrent, 1); }

		var indexOfScreen = usersOnScreen.indexOf(streamId);
		if ( indexOfScreen > -1 ) { usersOnScreen.splice(indexOfScreen, 1); }

		//var visibleLength = $(".cam_live_container:visible").length;
		var visibleLength = usersOnScreenCurrent.length;
		//console.log('checkForInterval visibleLength---', visibleLength);
		
		if ( visibleLength < maxOnScreen )
			{
				fillUpUsersOnScreenCurrent();
			}
		
		//console.log('usersOnScreenCurrent******************************');
		//console.log(usersOnScreenCurrent);
			
		visibleLength = usersOnScreenCurrent.length;
		
		if ( visibleLength <= maxOnScreen && window['switchStreamsInterval'] )
			{
				//console.log('clear interval---', streamId);
				clearInterval(window['switchStreamsInterval']);
				window['switchStreamsInterval'] = null;
			} 
	}
	
	function fillUpUsersOnScreenCurrent()
		{
			var maxOnScreen = currentUserData.default.participantMaxUserLimit;
			streamArray.forEach((stream) => {
				if ( usersOnScreenCurrent.length < maxOnScreen )
					{
						if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId && usersOnScreen.indexOf(stream.getId()) == -1)
							{
								var userDetails = collection.getDetailsById(stream.getId());
								if ( usersOnScreenCurrent.indexOf(userDetails.id) == -1 )
									{
										if ( userDetails && userDetails.broadcastVideo !== false )
											{
												subscribeToVideoStream(userDetails.id);
											}
										else
											{
												$('#participant_stream'+userDetails.id).addClass('d-none');
												$('#nocam'+userDetails.id).removeClass('d-none');
											}
										//console.log('push1');
										//console.log(userDetails.id);
										usersOnScreen.push(userDetails.id);
										usersOnScreenCurrent.push(userDetails.id);
										$('#participant_stream_content'+userDetails.id).removeClass('d-none');
									}
							}
					}
			});
			
			streamArray.forEach((stream) => {
				if ( usersOnScreenCurrent.length < maxOnScreen )
					{
						if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
							{
								var userDetails = collection.getDetailsById(stream.getId());
								if ( usersOnScreenCurrent.indexOf(userDetails.id) == -1 )
									{
										if ( userDetails && userDetails.broadcastVideo !== false )
											{
												subscribeToVideoStream(userDetails.id);
											}
										else
											{
												if ( userDetails.id !== currentSharedUser )
													{
														$('#participant_stream'+userDetails.id).addClass('d-none');
														$('#nocam'+userDetails.id).removeClass('d-none');
													}
											}
										//console.log('push2');
										//console.log(userDetails.id);
										usersOnScreenCurrent.push(userDetails.id);
										$('#participant_stream_content'+userDetails.id).removeClass('d-none');
									}
							}
					}
			});
						
			//console.log(usersOnScreen);
			//console.log(usersOnScreenCurrent);
		}
	
	function setParticipantResolutionToLow(stream) {
      client.setRemoteVideoStreamType(stream, Const.STREAM_TYPE.LOW);
	}
	
	function hideControls(id) {
      var video = document.getElementById("video"+id);
      if (video) { video.removeAttribute("controls"); }
	}
	
	function inactivityTime() {
        var time;
        var defTimer = 20;
		
		if ( currentUserData.default.hideMenuTimer )
			{
				defTimer = parseInt(currentUserData.default.hideMenuTimer);
			}
        // events
        window.onclick = resetTime;
        window.onkeypress = resetTime;
        window.ontouchstart = resetTime;
        window.onmousemove = resetTime;
        window.onmousedown = resetTime;
        window.addEventListener('scroll', resetTime, true);

        function alertUser() {
            // do your task here
            hideAllElements();
        }

        function resetTime() {
            clearTimeout(time);
            time = setTimeout(alertUser, 1000 * defTimer); // 10 seconds
			showAllElements();
        }
		
		resetTime();
    };
	
	// run the function
    inactivityTime();
	
	function hideAllElements()
		{
			if ( ( $('#onlinetext').text() == 'ONLINE' || currentUserData.sessionData.ondemandId > 0 ) && !window['clickedOnLogout'] )
				{
					$('.menu_hidden_item').addClass('opacityHide');
					//$('.right_stream').addClass('opacityHide');
					$('.abs_border').addClass('d-none');
					
					$('.session_data_container').addClass('d-none');
					$('.networkMsgHolder').addClass('networkMsg_moreWidth');
					$('.session_time').addClass('timerColor');
					$('#memberControlsHolder').addClass('transBackgroundColor');
					$('.participant_view_container').addClass('opacityHide');
					if ( currentUserData.sessionData.ondemandId == 0 ) 
						{ 
							$('.left_stream').addClass('unactive_screen_activity'); 						
						}		
					else 
						{
							$('.main_progress_container').addClass('opacityHide'); 
						}
					$('.participant_header').addClass('hidenElementsInHeader');
					
					
					if ( $('#my_stream_main').hasClass('d-none') )
						{
							$('#mine_stream').addClass('opacityHide');
						}
						
					if ( $('#members_inner_main').hasClass('d-none') )
						{
							$('#participants_streams').addClass('opacityHide');
						}
					
					$('.participant_streaming_container').addClass('hiddenItems');
					$('#virtualmsg').addClass('not_supported_hidden');
					$('.participant_player').addClass('d-none'); 
					window['showAllElementsStatus'] = false;
				}
					
		}
	
	function showAllElements()
		{
			$('.menu_hidden_item').removeClass('opacityHide');
			//$('.right_stream').removeClass('opacityHide');
			$('.abs_border').removeClass('d-none');
			$('.session_data_container').removeClass('d-none');
			$('.networkMsgHolder').removeClass('networkMsg_moreWidth');
			$('.session_time').removeClass('timerColor');
			$('#memberControlsHolder').removeClass('transBackgroundColor');
			$('.participant_view_container').removeClass('opacityHide');	
			$('.left_stream').removeClass('unactive_screen_activity');
			if ( currentUserData.sessionData.ondemandId > 0 ) { $('.main_progress_container').removeClass('opacityHide');  }
			$('#participants_streams').removeClass('opacityHide');	
			$('#mine_stream').removeClass('opacityHide');
			$('.participant_streaming_container').removeClass('hiddenItems');	
			$('.participant_player').removeClass('d-none');		
			$('.participant_header').removeClass('hidenElementsInHeader');
			$('#virtualmsg').removeClass('not_supported_hidden');
			window['showAllElementsStatus'] = true;			
		}	
		
	window['showAllElements'] = showAllElements;
	
	function incrementcountAtAttendies(userDetails, type) {
		if ( type == 'Joined' )
			{
				if ( userDetails.email == currentUserData.sessionData.hostEmail )
					{
						$('#onlinetext').text('ONLINE');
						$('#onlineicon').removeClass('d-none');
						$('#offlineicon').addClass('d-none');
						checkForMicCamPermission();
						currentUserData.sessionData.isHostOffline = 0;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
					}
			}
	}
	
	function rtmJoin() {
		if ( newclient == undefined || channel == undefined )
			{
				newclient = AgoraRTM.createInstance(rtmAppId, {enableLogUpload: false, logFilter: AgoraRTM.LOG_FILTER_OFF});
		
				newclient.on('MessageFromPeer', (message, peerId) => { 
					console.log('MessageFromPeer - ', message.text, peerId);
					signalHandler(peerId, message.text, currentUserData.userType);
				});
				
				newclient.on('ConnectionStateChanged', (newState, reason) => {
					if ( reason == 'REMOTE_LOGIN' )
						{
							newclient.logout();
							window.logoutRemoteUser();	
							
							let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "logout", "userId": currentUserData.id, "details": JSON.stringify({"status":"success", "msg": "Remote Login"}), "timestamp": Util.getCurrentTimestamp()};
							sessionDataStore.addSessionData(addObject);
						}
					else
						{
							if ((newState == 'ABORTED' || newState == 'DISCONNECTED') && (reason == 'LOGIN_TIMEOUT' || reason == 'INTERRUPTED' || reason == 'REMOTE_LOGIN' || reason == 'LOGIN_FAILURE' || reason == 'BANNED_BY_SERVER'))
								{
									newclient.logout();
									setTimeout(doClientLogin, 500);
								}
						}
				});
				
				doClientLogin();
			}
	}
	
	window.logoutRemoteUser = () => { 
		$('#multi-device-login-alert').modal('show')
		rtm.invoke({'code': 51});
		leave(); 
	}
	
	window.checkUnreadMessages = () => {
		var unreadMessagesNum = localStorage.getItem('unreadMessagesNum');
		if ( unreadMessagesNum )
			{
				unreadMessagesNum = parseInt(unreadMessagesNum);
				if ( $('#chat_menu').css('display') == 'none' )
					{					
						var messagesCounter = $('#chat_counter').text();
						messagesCounter = parseInt(messagesCounter);
						messagesCounter = messagesCounter + unreadMessagesNum;
						$('#chat_counter').text(messagesCounter);
						$('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}
			}
	}
	
	function addToSessionUsers(data) {
		var participantModelObj = new ParticipantModel();

		participantModelObj.id = data.id;
		participantModelObj.firstName = data.firstName;
		participantModelObj.lastName = data.lastName;
		participantModelObj.email = data.email;
		participantModelObj.image = data.image;
		participantModelObj.userType = data.userType;
	
		//console.log('streaming controler addToSessionUsers');
		collection.addModel(participantModelObj);

		let tempUserData = getTempUsers();
		tempUserData.push(data);
		localStorage.setItem('tempUsers', JSON.stringify(tempUserData));
	}
	
	window['addUserToGlobalModel'] = function(data)
		{
			let findUserInModel = collection.getDetailsById(data.id);
			if ( !findUserInModel )
				{
					var participantModelObj = new ParticipantModel();

					participantModelObj.id = data.id;
					participantModelObj.firstName = data.firstName;
					participantModelObj.lastName = data.lastName;
					participantModelObj.email = data.email;
					participantModelObj.image = data.image;
					//console.log('streaming controler addUserToGlobalModel');
					participantModelObj.userType = data.userType;

					collection.addModel(participantModelObj);
				}
		}
	
	function iterateParticipants() {
		let userList = getTempUsers();

		for (var i = 0; i < userList.length; i++) {

          var  participantModelObj = new ParticipantModel();

          participantModelObj.id = userList[i].id;
          participantModelObj.firstName = userList[i].firstName;
          participantModelObj.lastName = userList[i].lastName;
          participantModelObj.email = userList[i].email;
          participantModelObj.image = userList[i].image;
          participantModelObj.userType = userList[i].userType;
          participantModelObj.currentStatus = userList[i].currentStatus !== undefined ? userList[i].currentStatus : null;
          participantModelObj.broadcastVideo = userList[i].broadcastVideo !== undefined ? userList[i].broadcastVideo : null;
		  //console.log('streaming controler iterateParticipants');
          collection.addModel(participantModelObj);
		}
	}
	
	function getTempUsers(){
		return localStorage.getItem("tempUsers") != undefined ? JSON.parse(localStorage.getItem("tempUsers")) : [];
	}
	
	function leave() {
		if ( window['electron'] && client && client['agora'] && client['agora'].muteAllRemoteVideoStreams )
			{
				client.muteAllRemoteVideoStreams();
				client.muteAllRemoteAudioStreams();
			}
			
		client.leave(function () {
			if( localStream && localStream.isPlaying() ) {
				localStream.stop();
			}
			
			if ( localStream )
				{
					localStream.close();
				}
			
			
			streamArray.forEach((stream)=>{
				if ( !window['electron'] ) 
					{  
						if(stream.isPlaying()) {
							stream.stop();
						}
					}
			});	
		}, function (err) { });
	}
	
	function checkSessionUser(email) {
		let userList = getTempUsers();
		if ( userList != '' ) 
			{
				var sessionUserExists = false;

				for(let i = 0; i < userList.length; i++){
					if(userList[i].email == email){
						sessionUserExists = true;
					}
				}

				if (sessionUserExists === true) 
					{
						return true;
					} 
				else 
					{
						return false;
					}
			} 
		else 
			{
			  return false;
			}
	}
	
	function addUserAttribute(id, key, value){
		let tempUsers = getTempUsers();

		if(tempUsers != null){
			for(let i in tempUsers){
			  if(tempUsers[i].id == id){
				 //console.log('tempUsers[i].id');
				 //console.log(tempUsers[i].id);
				 //console.log(tempUsers[i][key]);
				 //console.log(key);
				 //console.log(value);
				tempUsers[i][key] = value;
			  }
			}
		}
		
		if ( window.updateParticipantsData )
			{
				window.updateParticipantsData(id, key, value);
			}
		localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
		console.log('addUserAttribute tempUsers');
		console.log(tempUsers);
	}
	
	function doClientLogin(){
		//console.log('doClientLogin');
		newclient.login({ token: token, uid: peer }).then(() => {
			channel = newclient.createChannel(rtmChannelId);
			channel.join().then(() => {
				channel.on('MemberJoined', memberId => { 
					let remoteUser = memberId.includes("RM-");
					let userExists = true;
					
					if ( !remoteUser ) { userExists = checkSessionUser(memberId); }
					if ( userExists )
						{
							let userDetails = collection.getDetailsByEmail(memberId);
							addUserAttribute(userDetails.id, 'isOnline', true);
						}
						
					if ( !userExists )
						{
							var userData = {email: memberId};
							
							axios.post(Const.BASE_API_PATH+'/api/v1/user/checkUserExist', userData).then(res => {
								res.data.responseData.userType = 2;
								res.data.responseData.isOnline = true;
								
								if ( !res.data.responseData.image || res.data.responseData.image == 'null' || ( res.data.responseData.image !== '' && res.data.responseData.image.indexOf('.s3') == -1 ) )
									{
										res.data.responseData.image = './images/user_avatar.svg';
									}
									
								addToSessionUsers(res.data.responseData);
							}).catch(err =>{ });   
						}
				});
				
				channel.on('MemberLeft', memberId => {
					if(memberId.includes("RM-") === false) {
						setTimeout(function(){
							let text = "1100" + sep;
							checkAvailableAtRTM(memberId, text);
						}, 10000);
					}
					
					if ( memberId == currentUserData.sessionData.hostEmail )  
						{
							setHostOffline();
						}
				});
				
				channel.on('ChannelMessage', window.onChannelMessage);
			}).catch(error => {
				let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "RTM Channel Join", "msg": error}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			});
		}).catch(err => {
			
		});
	}
	
	function checkAvailableAtRTM(peerId, text) {
	
	    if ( !newclient ) { 
			//console.log('not found', text); 
			return false; 
		}

      newclient.sendMessageToPeer({text}, peerId).then(sendResult => {

        if (sendResult.hasPeerReceived) {
            rtmRetryCounter = 0;

            let userDetails = collection.getDetailsByEmail(peerId);
            let updateObject = {"isAvailableAtRTM": true};
            collection.updateModel(userDetails.id, JSON.stringify(updateObject));
        } else {            

            if (rtmRetryCounter < 2) {
                rtmRetryCounter++;
                checkAvailableAtRTM(peerId, text);
            } else {

                rtmRetryCounter = 0;

                let userDetails = collection.getDetailsByEmail(peerId);
                let updateObject = {"isAvailableAtRTM": false};
                collection.updateModel(userDetails.id, JSON.stringify(updateObject));

                removeParticipant(userDetails);
            }
        }
      }).catch(error => {
          rtmRetryCounter = 0;

          let userDetails = collection.getDetailsByEmail(peerId);
          let updateObject = {"isAvailableAtRTM": false};
          collection.updateModel(userDetails.id, JSON.stringify(updateObject));

          removeParticipant(userDetails);
      });
  }
  
  function removeParticipant(userDetails) {
      if ((userDetails.isAvailableAtRTC === null || userDetails.isAvailableAtRTC === false) && userDetails.isAvailableAtRTM === false && (userDetails.isVisible === true || userDetails.isVisible === false)) {

          resetParticipantAttributes(userDetails.id);
          removeStreamFromArray(userDetails.id);
          incrementcountAtAttendies(userDetails, 'Left');

          //console.log('###Function - removeParticipant - not available in both RTM & RTC: ' + userDetails.id + ' ' + userDetails.email);
      }

      removeUserAttribute(userDetails.id, 'broadcastVideo');
      addUserAttribute(userDetails.id, 'isOnline', false);
  }

  function resetParticipantAttributes(userId) {
      let updateObject = {"currentStatus": null, 
                            "isVisible": null, 
                            "subscribeTime": null, 
                            "audioMuted": null, 
                            "videoMuted": null,
                            "isAvailableAtRTC": null,
                            "isAvailableAtRTM": null,
                            "broadcastVideo": null,
                            "debounceValue": null
                        };

      collection.updateModel(userId, JSON.stringify(updateObject));
  }
  
	function removeUserAttribute(id, key) {
      let tempUsers = getTempUsers();

      if(tempUsers != null){
        for(let i in tempUsers){
          if(tempUsers[i].hasOwnProperty(key) && tempUsers[i].id == id){
            delete tempUsers[i][key];
          }
        }
      }
        
      localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
	}
	
	function continueJoin(){
		rtmJoin();
		rtcJoin();

		if (currentUserData.sessionData.showOtherParticipants == 1) 
			{
				//switchUsers();
			}
	}
	
	continueJoin();
	
	function sendMessage(peerId, text){
		if ( !newclient ) { return false; }
		
		newclient.sendMessageToPeer({text}, peerId).then(sendResult => {
			if ( sendResult.hasPeerReceived )
				{
					retryCounter = 0; 
				}
			else
				{
					if ( retryCounter <= 3 )
						{
							 retryCounter++;
							 
							setTimeout(function(){
								sendMessage(peerId, text);
							}, 500);
						}
					else
						{
							retryCounter = 0;
						}
				}
		}).catch(error => { retryCounter = 0; });
	}
	
	window['globalRTM'] = sendMessage;
	
	var cameraStreams = [];
	function getDevices() { 
		$('#camera_options').html('');
		$('#microphone_options').html('');
		$('#speaker_options').html('');
		
		var indexMic = 0;
		var indexCam = 0;
		let cameraFoundStatus = false;
		let cameraId = null;
		let micId = null;
		let speakId = null;
		let mediaIds = localStorage.getItem(hostlanguage.mediaSetting);
		let foundCamera = false;
		let foundMicrophone = false;
		if ( mediaIds !== undefined )
			{
				mediaIds = JSON.parse(mediaIds);
				
				if ( mediaIds.camera != null ) { foundCamera = true; }
				if ( mediaIds.microphone != null ) { foundMicrophone = true; }
				
				if ( mediaIds.camera != null && mediaIds.microphone != null )
					{
						cameraId = mediaIds.camera;
						micId = mediaIds.microphone;
						window['main_mic_id_gue'] = mediaIds.microphone;
						speakId = mediaIds.speaker; 
					}
				
				if (currentUserData && currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 && foundCamera && !foundMicrophone) 
					{
						cameraId = mediaIds.camera;
						speakId = mediaIds.speaker;
					}						
			}
		
		AgoraRTC.getDevices(function (devices) {
			for ( var i = 0; i < devices.length; i++ )
				{
					var checked = '';
					let cameraAccessAllowed = localStorage.getItem('cameraAccessAllowed');
					if ( devices[i].kind === 'videoinput' )
						{
							if ( cameraId == devices[i].deviceId || cameraId == '' )
								{
									cameraIndex = indexCam;
									cameraId = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
									cameraFoundStatus = true;
									
									if ( !cameraAccessAllowed )
										{
											cameraFoundStatus = false;
										}
								}
								
							var videoOptionHtml = '<div class="drop_option cam_option'+indexCam+'"  id="chose_camera" data-keyid='+indexCam+'>'+devices[i].label+' '+checked+'</div>';
							var cameraOptions = document.getElementById('camera_options');
							if ( cameraAccessAllowed )
								{
									cameraOptions.innerHTML += videoOptionHtml;
								}
								
							cameraStreams[indexCam] = AgoraRTC.createStream({
							  streamID: Math.floor(Math.random()*1000000),
							  video: true,
							  audio: false,
							  cameraId: devices[i].deviceId,
							});
							
							cameraIds.push('cam_option'+indexCam+'');
							indexCam++;
							window['cameraFoundStatus'] = cameraFoundStatus;
						}
						
					if ( devices[i].kind === 'audioinput' && !currentUserData.sessionData.ondemandId )
						{
							if ( micId == devices[i].deviceId || micId == '' )
								{
									micId = devices[i].deviceId;
									window['main_mic_id_gue'] = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
								}
								
							var micOptionHtml = '<div class="drop_option mic_option'+indexMic+'" id="chose_mic" data-keyid='+devices[i].deviceId+'>'+devices[i].label+' '+checked+'</div>';
							var micOptions = document.getElementById('microphone_options');
							micOptions.innerHTML += micOptionHtml;
							
							microphoneIds.push('mic_option'+indexMic+'');
							indexMic++;
						}
						
					if ( devices[i].kind === 'speaker' && !currentUserData.sessionData.ondemandId )
						{
							if ( speakId == devices[i].deviceId )
								{
									speakId = devices[i].deviceId;
									checked = '<div class="drop_checked"></div>';
								}
								
							var speakOptionHtml = '<div class="drop_option" id="chose_speak" data-keyid='+devices[i].deviceId+'>'+devices[i].label+' '+checked+'</div>';
							var speakOptions = document.getElementById('speaker_options');
							speakOptions.innerHTML += speakOptionHtml;
						}
				}
		});
	
	}
	
	getDevices();
	window['getDevices'] = getDevices;
	
	function swithMicAndSpeaker(){
		let mediaSetting = localStorage.getItem(hostlanguage.mediaSetting);
		mediaSetting = JSON.parse(mediaSetting);
		
		localStream.switchDevice("audio", mediaSetting['microphone'].toString(), function(){
			if( mediaSetting['speaker'] ){ localStream.switchDevice("speaker", mediaSetting['speaker'].toString(), function() {}); }
			if ( window['ipad'] == undefined && dualStreamEnabled === true ) {
				enableDualStream();
			}
		},function(e){
		  if (window['ipad'] == undefined && dualStreamEnabled === true) {
			enableDualStream();
		  }
	  });
	}
	
	function sendFitnessEmoji(type, event) {
		let message = RTMConst.SEND_EMOJI+sep+type;
        sendMessageToChannel(message);

        animateEmojis(type, currentUserData.firstName, 'fitness');
        event.preventDefault();
    }
	
	function animateEmojis(emotIcon, uname, category = '') {

		uname = uname.toLowerCase();
		let partcipantName = uname.charAt(0).toUpperCase() + uname.slice(1).toLowerCase();

		if (category == 'bpm') {
			$('.particlecontainer').append('<span class="particle"><img src="./images/heart.png" /><span class="text-white participant-bpm">'+emotIcon+'</span><span class="bottomtext">'+partcipantName+'</span></span>');
		} else if (category == '') {
			$('.particlecontainer').append('<span class="particle"><span class="toptext">'+emotIcon+'</span><span class="bottomtext">'+partcipantName+'</span></span>');
		} else {
			$('.particlecontainer').append('<span class="particle"><img src="./images/'+Const.APPEREANCE[emotIcon]+'" /><span class="bottomtext">'+partcipantName+'</span></span>');
		}

		$('.particle').toArray().forEach(function(particle) {

			$(particle).animate({

				  right: generateRandomNumber(0, $('.particlecontainer').width())

			}, generateRandomNumber(10, 30), function() {       

				$(particle).animate({
					top: -50 + "%"
				}, generateRandomNumber(8000, 10000), function() {
					$(particle).remove();
				});
			});
		});
	  }
	  
	var generateRandomNumber = function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
	}
  
	function enableDualStream() {
		client.enableDualStream(function() {
          //console.log("Enable dual stream success!")
		}, function(err) {
          //console.log('Dual stream error====', err);
		});
	}
	
	function publish() {
		if ( currentUserData.unmuteAllEnabled === true ) 
		{
			$('#mic_control').removeClass('d-none');
			//$('#speak_control').removeClass('d-none');
		} else {
			localStream.muteAudio();
		}

		streamPublished = true;

		client.publish(localStream, function (err) {
			let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status":"Publish Stream", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
			sessionDataStore.addSessionData(addObject);
		});

		client.on('stream-published', function (evt) {});
	}
	
	function changeCameraStream(){
		let mediaSetting = localStorage.getItem(hostlanguage.mediaSetting);
		mediaSetting = JSON.parse(mediaSetting);
		let vdId = mediaSetting['camera'];
		
		if ( vdId )
			{
				let myStream = !window['streamSwapped'] ? 'mystream' : window['injectedStarted'] ? 'injected_pip_video' :'host_stream';
				
				if ( is_ffox )
					{
						var localStream3 = AgoraRTC.createStream({audio: false, video: true, cameraId: vdId.toString()});
						localStream3.setVideoProfile(Const.PARTICIPANT_RESOLUTION[localStorage.getItem("video-resolution")]);
						
						localStream3.init(function(){
								var newVideoTrack = localStream3.getVideoTrack();
								localStream.replaceTrack(newVideoTrack);
								  
								if ( window['electron'] ) { localStream.play(myStream); }

								if (window['ipad'] == undefined && dualStreamEnabled === true) {
								  enableDualStream();
								}
							},function(e){
								if ( window['electron'] ) { localStream.play(myStream); }

							if (window['ipad'] == undefined && dualStreamEnabled === true) {
							  enableDualStream();
							}
						});
					}
				else
					{
						localStream.switchDevice("video", vdId.toString(), function(){
						  if ( window['electron'] ) { localStream.play(myStream); window['changeCameraRes'](window['currentResolution']); }
						  
						  if (window['ipad'] == undefined && dualStreamEnabled === true) {
							enableDualStream();
						  }
						},function(e){
						  if ( window['electron'] ) { localStream.play(myStream); }
						  
						  if (window['ipad'] == undefined && dualStreamEnabled === true) {
							enableDualStream();
						  }
						});
					}
			}
	}
	
	function leave_channel() {
      if ( newclient && newclient != undefined )
		{
          newclient.logout();
          newclient = undefined;
		}
	  
      if(channel)
        channel.leave();
	}
	
	function sendMessageToChannel(text){
	  console.log('sendMessageToChannel', text);
      if ( !channel ) { 
			//console.log('not found', text); 
			return false; 
		}
      channel.sendMessage({text}, rtmChannelId).then(() => {
          retryCounter = 0;
      }).catch(error => {
        //console.log('channel message failed----', error);

        if (retryCounter <= 3) {
            retryCounter++;

            setTimeout(function(){
                sendMessageToChannel(text);
            }, 500);
        } else {
            //console.log('channel message retryCounter====limit exceeded', retryCounter);
            retryCounter = 0;
        }
      });
	}
	
	window['sendMessageToChannel'] = sendMessageToChannel;
	
	
	function signalHandler(uid, signalData, userType) {
		//console.log('Function - signalHandler - ' + signalData + ' - email: ' + uid);
		
		let resultant = signalData.split(sep);
		let peerId  = null;
		let userDetails = null;
		
		 if ( uid == currentUserData.sessionData.hostEmail && window['electron'] )
			{
				sendMessage(currentUserData.sessionData.hostEmail, 'participantElectron'+sep);
			}
		
		if (uid.includes("RM-") === false) {
			userDetails = collection.getDetailsByEmail(uid);
			peerId      = userDetails.id;
		} else {
			peerId = uid;
		}
		
		if ( resultant[0] == RTMConst.SYNC_SCRIPT && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				syncParticipantScript(resultant);
			}
			
		if ( resultant[0] == RTMConst.NEXT_SCRIPT )
			{
				if ( resultant[2] )
					{
						if ( lastScriptCode >= parseInt(resultant[2]) )
							{
								return false; //do nothing, second time or previous code
							}
						
						lastScriptCode = resultant[2];
					}
				
				console.log("NEXT SCRIPT RTM");
				var nextAct = true;
				var pauseAct = undefined;
				let indexNum = 0;
				if ( resultant[1] )
					{
						//pauseAct = JSON.parse(resultant[2]);
						indexNum = JSON.parse(resultant[1]);
					}
				
				if ( window.checkRTMtimeout )
					{
						clearTimeout(window.checkRTMtimeout);
					}
				
				if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout )
					{
						clearTimeout(window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout);
						window['userWhiteboard'][currentUserData.id].clearMessageInstructions();
						if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
					}
				
				var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
				
				if ( workoutArray[indexNum] && workoutArray[indexNum]['attribute'][0]['attrValue'] != 'Pause' && workoutArray[indexNum]['attribute'][0]['attrValue'] != 'Pause Virtual' )
					{
						let nextNum = indexNum + 1;	
						window['utcTimeMember'] = Util.getUTCTimestamp();
						$('#partBigCounter').addClass('d-none');
						$('.virtualDisabledMsg').addClass('d-none');
						if ( window['deviceNotSupported'+currentUserData.id] )
							{
								$('#virtualmsg').text('').addClass('d-none');
							}
						window['scriptStarted'] = true;
						window['usingPose'] = true;
						window.isPaused = true;
						window.setCurrentActivity(nextAct, pauseAct, indexNum);
						window.setNextActivityParticipants(nextNum);
						window.pauseVirtualActivityStarted = false;
						//setTimeout(function(){ $('#canvasWrap').removeClass('hostVirtualOnMember'); console.log('hostFlipRemove 222'); }, 100);
						
						if ( resultant[1] && window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] )
							{
								var currentActIndex = parseInt(resultant[1]);
								window['allowReadyGo'] = true;
								window['playCountdown'] = true;
								
								if ( window['userWhiteboard'][currentUserData.id].trackerActions.turnOffMediaPipe ) 
									{ 
										setTimeout(function() { window['userWhiteboard'][currentUserData.id].trackerActions.toggleMediaPipe(false); }, 1000);
									}
								
								var virtualActivity = window.setNextActivityVirtual(currentActIndex);
								
								window['userWhiteboard'][currentUserData.id].currentActivityName = virtualActivity;
								window['userWhiteboard'][currentUserData.id].activityStarted(virtualActivity);
								
								window.setNextActivityVirtual(currentActIndex, 0);
							}
					}
				else
					{
						let nextActivity = workoutArray[indexNum+1];
						console.log('nextActivity', nextActivity);
						if ( nextActivity ) 
							{
								if ( nextActivity['attribute'][0]['attrValue'] == 'Pause' || nextActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
									{
										nextActivity = workoutArray[indexNum+2];
									}
								console.log('nextActivity2', nextActivity);
									
								if ( nextActivity && (nextActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || nextActivity['attribute'][0]['attrValue'] == 'Virtual Assistant') )
									{	
										var script_name = nextActivity['name'];
										window.setPauseVirtualActName(script_name);
										
										if ( currentUserData.sessionData.ondemandId > 0 ) { 
											window.setCurrentActivity(nextAct, pauseAct, indexNum);
										}
										if ( window['openParticipantList'] )
											{
												window['hideMembersOnVirtualActivity']();
												window['hideMemberOnVirtual'] = true;
											}
										
										if ( workoutArray[indexNum]['attribute'][0]['attrValue'] == 'Pause' )
											{
												startPauseActivity(script_name);
											}
										else if ( workoutArray[indexNum]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												startPauseVirtualActivity(script_name);
											}
											
										let pauseActivityDuration = workoutArray[indexNum]['attribute'][2]['attrValue'] * 1000;
											
										window.checkRTMtimeout = setTimeout(function() {
											var sep = '~@$';
											if ( window['globalRTM'] && currentUserData['sessionData'] ) { window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'checkActivityRTM'+sep); }
										}, pauseActivityDuration + currentUserData.default.nextActivityTimeout);
											
										$('#canvasWrap').removeClass('d-none');
									}
							}
					}
				
				//window['allowReadyGo'] = false;
			}
			
		if ( resultant[0] == RTMConst.SYNC_WHEN_PAUSE_ACTIVITY && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				if ( window['setIndexNumAfterSync'] )
					{
						window['setIndexNumAfterSync'](resultant[1]);
					}
			}	
			
		if ( resultant[0] == RTMConst.CHAT )
			{
				if ( uid.includes("RM-") ) 
					{
						uid = uid.split('RM-')[1];
						userDetails = collection.getDetailsByEmail(uid);
					}
					
				let peerName = '';
				if ( resultant[3] != undefined ) 
					{
						let peerDetails = collection.getDetailsByEmail(resultant[3]);
						peerName = peerDetails.firstName;
					}
					
				window.onReceiveMessage(userDetails, resultant[1], "p2p", resultant[2], peerName);
				
				if ( $('#chat_menu').css('display') == 'none' )
					{					
						var messagesCounter = $('#chat_counter').text();
						messagesCounter++;
						$('#chat_counter').text(messagesCounter);
						$('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}
			}
			
		if ( resultant[0] == RTMConst.CHAT_SYNC )
			{
				let chats = JSON.parse(resultant[1]);
				chats.forEach((chatData) => { window.syncChat(chatData); });
			}
			
		if ( resultant[0] == RTMConst.EJECT_PARTICIPANT )
			{
				
				var userData = JSON.parse(localStorage.getItem('userData'));
				userData.sessionData.ejectedUser = true;
				localStorage.setItem("userData", JSON.stringify(userData));
				rtm.invoke({'code': 51, 'logout': true});
			}
			
		if ( resultant[0] == RTMConst.BPM_HEART_RATE )
			{
				let hrData = JSON.parse(resultant[1]);
				setBPMAtParticipant(hrData);
				let text = RTMConst.BPM_HEART_RATE + sep + hrData['heartRate'];
				sendMessageToChannel(text);
			}

		if ( resultant[0] == RTMConst.OPEN_MIC )
			{
				if ( isMutedByMe ) { return false; }
				
				let showMsg = true;
				if ( $('.audio_icon .muted_audio').is(":hidden") ) { showMsg = false; }
				
				if ( hostStreamMuted === false ) { unmuteParticipantAudio(); }
				localStream.unmuteAudio();
				
				$('#microphone_control').text('Mute Microphone');
				$('.audio_icon .muted_audio').addClass('d-none');
				$('#mic_control .muted_audio').addClass('d-none');
				$('#raise_hand').addClass('d-none');
				$('#mic_control').removeClass('d-none');
				//$('#speak_control').removeClass('d-none'); 
				
				currentUserData.sessionData.isHiddenRaiseHand = 1;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
					
				if ( showMsg ) { rtm.invoke({'code': RTMConst.UNMUTE_ALL}); }
			}
			
		if ( resultant[0] == RTMConst.TURN_MIC_OFF )
			{
				if ( isMutedByMe ) { return false; }
				
				let showMsg = true;
				if ( $('.audio_icon .muted_audio').is(":visible") ) { showMsg = false; }
				
				localStream.muteAudio();
				
				if ( hostStreamMuted === false ) 
					{
						streamArray.forEach((stream) => {
							if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
								{
									stream.muteAudio();
								}
						});
					}
					
				$('#microphone_control').text('Unmute Microphone');
				$('.audio_icon .muted_audio').removeClass('d-none');
				$('#mic_control .muted_audio').removeClass('d-none');
				if ( !currentUserData.unmuteAllEnabled )
					{
						$('#raise_hand').removeClass('d-none');
					}
				
				currentUserData.sessionData.isHiddenRaiseHand = 0;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				
				if ( showMsg && currentUserData.isMarketplaceChannel == 0 ) { rtm.invoke({'code': RTMConst.MUTE_ALL}); }
			}
		if ( resultant[0] == RTMConst.HOST_UNPINNED_PARTICIPANT )
			{
				$('#raise_hand').removeClass('d-none');
			}			
		if ( resultant[0] == 'closeDraw' )
			{
				//console.log(resultant[1]);
				if ( window['streamSwapped'] && !window['injectedStarted'] && !window['highlightActive'] ) 
					{ 
						window['closeDrawStatus'] = true;
						swapStreamVirtual(true); 
					}
				if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.timerRunning == 'r' )
					{
						window['resetTimer']('r');
					}
				else if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.timerRunning == 'h' )
					{
						window['resetTimer']('h');
					}
					
				if ( window['userWhiteboard'][currentUserData.id] )
					{
						window['userWhiteboard'][currentUserData.id].trackerActions.setTrackerBackground = false;
					}
			}
			
		if ( resultant[0] == 'highlightDraw' )
			{
				if ( !window['scriptLoaded'] )
					{
						//loadWhiteboard();
						window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id});
					}
				
				window['scriptLoaded'] = true;
				window['shareAllStarted'] = true;
				window['canvasLinesBackup'+currentUserData.id] = window['userWhiteboard'][currentUserData.id].canvasLines;
				
				var splitSize = resultant[1].split('cSize');
				var linesPt = JSON.parse(splitSize[0]);
				
				window['linesPt'] = linesPt;
				console.log('linesPt', linesPt);
				var canvasSize = JSON.parse(splitSize[1]);
				shareAllUser = parseInt(resultant[2]);
				window['hostCanvasSize'] = canvasSize;
				console.log('highlightDraw1');
				window['highlightDraw'](shareAllUser);
				console.log('highlightDraw2');
				canvasScale();
			}
		
		if ( resultant[0] == 'grid' )
			{
				console.log('grid RTM received');
				window['gridOn'] = resultant[1] == 1 ? true : false;
				
				if ( !window['scriptLoaded'] )
					{
						//loadWhiteboard();
						window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id});
					}
				
				if ( window['canvasOn'] )
					{	
				console.log('grid timeout1');
						setTimeout(function(){window['userWhiteboard'][currentUserData.id].mouseActions.gridSwitch(true, window['gridOn'], resultant[2]); window['userWhiteboard'][currentUserData.id].drawLines();}, 1000);
					}
				else
					{
				console.log('grid timeout2');
						
						if ( window['waitBeforeDraw'] )
							{
								setTimeout(function(){
									if ( !window['canvasOn'] )
										{
											if ( !window['streamSwapped'] && !window['injectedStarted'] ) { window['canvasOn'] = true;  swapStreamVirtual(false, true); }
				console.log('grid timeout3');
											setTimeout(function(){window['userWhiteboard'][currentUserData.id].mouseActions.gridSwitch(true, window['gridOn'], resultant[2]); window['userWhiteboard'][currentUserData.id].drawLines();}, 1000);

										}
								}, 1000);
								window['waitBeforeDraw'] = false;
							}
						else 
							{
								if ( !window['canvasOn'] )
									{
										if ( !window['streamSwapped'] && !window['injectedStarted'] ) { window['canvasOn'] = true; swapStreamVirtual(false, true); }
				console.log('grid timeout4');
										setTimeout(function(){window['userWhiteboard'][currentUserData.id].mouseActions.gridSwitch(true, window['gridOn'], resultant[2]); window['userWhiteboard'][currentUserData.id].drawLines();}, 1000);
									}
							}	
					}
			}
			
		if ( resultant[0] == 'drawSplit' ) 
			{
				if ( resultant.length == 5 )
					{
						if ( !drawSplitArray[resultant[1]] ) { drawSplitArray[resultant[1]] = new Array(parseInt(resultant[2])+1); drawSplitArray[resultant[1]][0] = parseInt(resultant[2]); }
						drawSplitArray[resultant[1]][parseInt(resultant[3])+1] = resultant[4];
						drawSplitArray[resultant[1]][0]--;
						
						if ( drawSplitArray[resultant[1]][0] == 0 )
							{
								var oldid = resultant[1];
								drawSplitArray[oldid].shift();
								
								var newrtm = atob(drawSplitArray[oldid].join(''));
								resultant = newrtm.split(sep);
								drawSplitArray[oldid]=false;
							}
					}
			}
			
		if ( resultant[0] == 'draw' )
			{
				var linesPt = JSON.parse(resultant[1]);
				var drawTimeoutLength = 0;
				
				if ( window['waitBeforeDraw'] )
					{
						drawTimeoutLength = 1000;
						window['waitBeforeDraw'] = false;
					}
				
				setTimeout(function(){
					window['linesPt'] = linesPt;
					console.log('linesPt', linesPt);
					if ( !window['canvasOn'] )
						{
							if ( !window['streamSwapped'] && !window['injectedStarted'] && linesPt.length > 0 && !window['highlightActive'] )
								{
									window['isDrawingStarted'] = true;
									window['canvasOn'] = true;
									if ( (!window['userWhiteboard'][currentUserData.id] || (window['userWhiteboard'][currentUserData.id] && !window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured )) ) 
										{ 
											swapStreamVirtual(false, false); 
										}
									else 
										{ 
											swapStreamVirtual(false, true); 
										}
								}
						}
						
					window['hostCanvasSize'] = {'w': 1280, 'h': 720};
					var startRoomSetup = false;
					if ( resultant[2] == 'roomSetup' )
						{
							window['firstActSetup'+currentUserData.id] = true;
							window['pausedBeforeVirtual'] = true;
							startRoomSetup = true;
						}
					
					canvasScale(startRoomSetup);
				}, drawTimeoutLength);
			}
			
		if ( resultant[0] == 'hostStartedEquipment' ) 
			{
				  //console.log('HOST STARTED EQUIPMENT');
				  if ( window['deviceNotSupported'] || window['userCameraOff'] ) { return false; }
				  
				  window['soundPlay'].stopAudio();
				  window['hostStartedEquipment'+currentUserData.id] = true;
				  window['setTrackerBackground'+currentUserData.id] = false;
				  window['allowGettingPosition'] = true;
				  window['showInActiveZone'] = true;
				  $('#partMovedEquipment').addClass('d-none');
				  $('#setupEquipmentHold').addClass('d-none');
				  var script_name_participant = window.currentUserData.sessionData.scriptDetail[window['globalCurrentIndex']]['name'];
				 
				  window['showParticipantDirections'] = true;
				  window['directionsNotExpired'] = true;
				  window['plankZoneSet'] = false;
				  window['plankReachZoneSet'] = false;
				  
				  if ( currentUserData.sessionData.manualAutomaticScript != 1 )
					{
						$('.walk_tool_image').css('background-image', 'url(images/walk.png)').removeClass('d-none');
						$('#walkToolImage').removeClass('d-none');
						$('.walk_tool_text').html('Walk to the zone');
						$('#upNextText').removeClass('d-none');
						$('#upNextText').html('UP NEXT:');
						
						window['showMessageInstruction'](window['globalEquipmentObject'+currentUserData.id][window['globalActType']]['fullActName'], false, window['globalEquipmentObject'+currentUserData.id][window['globalActType']]['modifyLocationMessage']);
					
						if ( window['audioType'] !== 'offAudio' )
							{
								 if ( script_name_participant == 'Boxing Bag 1' )
									{
										window['soundPlay'].playAudio('boxingWalkToZone');
									}
								else if ( script_name_participant == 'Lateral Cone Touch' )
									{
										if ( !window['inConeZone'] ) { window['soundPlay'].playAudio('coneWalkToZone'); }
									}
								else if ( script_name_participant == 'Diagonal Cone Touch' )
									{
										if ( !window['inConeZone'] ) { window['soundPlay'].playAudio('coneWalkToZone'); }
									}
								else if ( script_name_participant == 'Squat' )
									{
										window['soundPlay'].playAudio('squatWalkToZone');
									}
							}
					}
				  
					window['startVirtualParticipant'](window['globalEquipmentObject'+currentUserData.id]['currentActivity']);
					  
					$('.participant_stats_hold, #repcounter, #perMinuteCounter, #virtualPunchHold, #virtualPunchMinuteHold').removeClass('d-none');
		  }
		  
		if ( resultant[0] == 'bagAttributes' )
			{
				var bagAttributes = JSON.parse(resultant[1]);
				
				window['bagAttributes'+currentUserData.id] = bagAttributes;
				window['alreadyDrawnBag'+currentUserData.id] = true;
			}
		
		if ( resultant[0] == 'ladderAttributes' )
			{
				var ladderAttributes = JSON.parse(resultant[1]);
				
				window['ladderAttributes'+currentUserData.id] = ladderAttributes;
				window['alreadyDrawnLadder'+currentUserData.id] = true;
			}
		
		if ( resultant[0] == 'resetEquipmentZones' )
			{
				window['ladderZoneSet'] = false;
				window['coneZoneSet'] = false;
				window['coneZoneSetDiag'] = false;
				window['boxingZoneSet'] = false;
				
				if ( !resultant[1] || (resultant[1] && resultant[1] != 'notMoved') )
					{	
						window['ladderMoved'+currentUserData.id] = true;
					}
				
				window.ladderDraw.resetLadderActiveZone();
			}
			
		if ( resultant[0] == 'resetConeZone' )
			{
				window['coneZoneSet'] = false;
				window['coneZoneSetDiag'] = false;
			}
			
		if ( resultant[0] == 'resetLadderZone' )
			{
				window['ladderZoneSet'] = false;
				
				if ( !resultant[1] || (resultant[1] && resultant[1] != 'notMoved') )
					{	
						window['ladderMoved'+currentUserData.id] = true;
					}
				
				window.ladderDraw.resetLadderActiveZone();
			}
			
		if ( resultant[0] == 'resetBoxingZone' )
			{
				window['boxingZoneSet'] = false;
			}
			
		if ( resultant[0] == 'resetHeightZone' )
			{
				window['heightZoneSet'] = false;
			}
		
		if ( resultant[0] == 'measuringSuccess' )
			{
				if ( window['audioType'] !== 'offAudio' && !window['heightSuccessPlayed'] ) 
					{ 
						window.soundPlay.stopAudio(); 
						window.soundPlay.playAudio('partHeightSuccess');
						window['heightSuccessPlayed'] = true;
					}
					
				
				$('#partToolTip .tooltipImage').addClass('d-none');
				$('.tooltipText').addClass('tool_tip_checkmark');
				$('.checkmark').addClass('checkmark_inline');
				$('#heightToolTip').addClass('d-none');
				window['showMessageInstruction'](window['globalEquipmentObject'+currentUserData.id]['heightSuccessMessage'], false);
				
				$('#walkToolImage').addClass('d-none');
				$('.walk_tool_text').html('');
				$('#partToolTip .tooltipSuccess').removeClass('d-none');
				for ( var i = 0; i < window['canvasLines'+currentUserData.id].length; i++ )
					{
						if ( window['canvasLines'+currentUserData.id][i]['t'] == 'c' && window['canvasLines'+currentUserData.id][i]['heightC'] )
							{
								window['canvasLines'+currentUserData.id].splice(i, 1);
								
								i--;
							}
					}
				
				window['measuringProcess'+currentUserData['id']] = false;
			}
		if ( resultant[0] == 'checkDeviceForVirtual' ) 
			{
				  window['checkDeviceForVirtual']();
			}
			
		if ( resultant[0] == 'hideElement' )
			{
				if ( window['hideCanvasElement'] ) { window['hideCanvasElement'](resultant[1]); }
			}
			
		if ( resultant[0] == RTMConst.UNMUTE_ALL )
			{
				$('#raise_hand').addClass('d-none');
				
				currentUserData.sessionData.isHiddenRaiseHand = 1;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
			}
		
		if ( resultant[0] == RTMConst.MUTE_ALL )
			{
				$('#raise_hand').removeClass('d-none');
				currentUserData.sessionData.isHiddenRaiseHand = 0;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
			}
			
		if( resultant[0] == RTMConst.REMOTE_VIDEO_LIST )
			{
				let showStatus = $('#participants_streams').hasClass('d-none');
				if (!showStatus)
					{
						$('#participantsStreamList').trigger('click');
					}
			}

		if( resultant[0] == RTMConst.REMOTE_PARTICIPANT_CAMERA_SETTING )
			{
				window['updateStateControls']({openAudioControls: false}); 
				window['updateStateFromChild']({openReactions: false});
				
				$('#cameraSettingsPop').trigger('click');
				remoteEvent = 'videoSettings';
				cameraIndexR = 0;
				
				if ( cameraIds.length > 0 )
					{
						$('.'+cameraIds[cameraIndexR]).addClass('highlight_option');
					}
			}

		if ( resultant[0] == RTMConst.REMOTE_PARTICIPANT_MIC_SETTING )
			{
				$('.one_emoji').removeClass('highlight_emoji');
				emojiesIndex = 0;
				window['updateStateFromChild']({openReactions: false});
				window['updateStateControls']({openVideoControls: false}); 
				
				$('#micSettingsPop').trigger('click');
				remoteEvent = 'audioSettings';
				
				if ( microphoneIds.length > 0 )
					{
						$('.'+microphoneIds[microphoneIndex]).addClass('highlight_option');
					}
			}

		if ( resultant[0] == RTMConst.REMOTE_ACTIVITY_LIST )
			{
				$('#viewAllAct').trigger('click');
			}
			
		if ( resultant[0] == RTMConst.REMOTE_RAISE_HAND )
			{
				if ( !$('#raise_hand').hasClass('d-none') )
					{
						$('#raise_hand').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.REMOTE_EMOJIES_OPEN )
			{
				$('.drop_option').removeClass('highlight_option');
				microphoneIndex = 0;
				window['updateStateControls']({openAudioControls: false, openVideoControls: false}); 
				
				$('#reactions_control').trigger('click');
				remoteEvent = 'emojies';
				$('#'+emojieIds[emojiesIndex]).addClass('highlight_emoji');
			}
			
		if ( resultant[0] == RTMConst.REMOTE_ZOOM_LOCAL )
			{
				if ( !$('#my_view_part').hasClass('d-none') )
					{
						$('#my_view_part').trigger('click');
					}
			}
			
		if ( resultant[0] == RTMConst.REMOTE_PARTICIPANT_LIST )
			{
				$('#member_control').trigger('click');
			}
			
		if ( resultant[0] == RTMConst.REMOTE_SPEAKER )
			{
				$('#speak_control').trigger('click');
			}
		
		if ( resultant[0] == RTMConst.SYNC_SESSION_RECORDING )
			{
				$('#record_info').removeClass('d-none');
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_ARROW_UP )
			{
				arrowEventChange('up');
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_ARROW_DOWN )
			{
				arrowEventChange('down');
			}
		
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_ARROW_LEFT )
			{
				arrowEventChange('left');
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_ARROW_RIGHT )
			{
				arrowEventChange('right');
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_OK )
			{
				confirmRemote();
			}
			
		if ( resultant[0] == RTMConst.PARTICIPANT_REMOTE_BACK )
			{
				remoteBack();
			}
		
			
		if ( resultant[0] == RTMConst.SYNC_SESSION_PLAYLIST )
			{
				$('#playlist_participant').removeClass('d-none');
				$('#songname').text(resultant[1]);
				$('#songartist').text(resultant[2]);
			}
		if ( resultant[0] == RTMConst.TURN_MIC_ON )
			{
				if ( isMutedByMe ) 
					{
						
						return false; 
					}
				
				let showMsg = true;
				if ( $('.audio_icon .muted_audio').is(":hidden") ) { showMsg = false; }
				
				if ( hostStreamMuted === false ) { unmuteParticipantAudio(); }
				localStream.unmuteAudio();
				
				$('#microphone_control').text('Mute Microphone');
				$('.audio_icon .muted_audio').addClass('d-none');
				$('#mic_control .muted_audio').addClass('d-none');
				$('#raise_hand').addClass('d-none');
				$('#mic_control').removeClass('d-none');
				//$('#speak_control').removeClass('d-none'); 
				
				currentUserData.sessionData.isHiddenRaiseHand = 1;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
					
				if ( showMsg ) { rtm.invoke({'code': RTMConst.UNMUTE_ALL}); }
			}
		if ( resultant[0] == 'getParticipantNotes' ) 
			{
				window['getSessionNotes']();
			}	
		if ( resultant[0] == RTMConst.SWITCH_VIDEO_BROADCAST ) 
			{
				console.log('SWITCH_VIDEO_BROADCAST signalHandler ------------------');
				let status = false;
				if (resultant[1] == 1) {
					status = true;
				}
				
				let userDetails = collection.getDetailsByEmail(uid);
				let updateObject = {"broadcastVideo": status};
				collection.updateModel(userDetails.id, JSON.stringify(updateObject));
				addUserAttribute(userDetails.id, 'broadcastVideo', status);
				
				if (window['openParticipantList'])
					{
						if ( usersOnScreenCurrent && usersOnScreenCurrent.length > 0 )
							{
								if ( usersOnScreenCurrent.indexOf(userDetails.id) > -1 )
									{
										if ( resultant[1] == 0 )
											{
												$('#nocam'+userDetails.id).removeClass('d-none');
												$('#participant_stream'+userDetails.id).addClass('d-none');
												
												if ( currentUserData.sessionData.showOtherParticipants == 1 ) //&& userDetails.isVisible
													{
														subscribeToAudioOnlyStream(userDetails.id);
													}
											}
										else
											{
												if ( userDetails.id !== currentSharedUser )
													{
														$('#nocam'+userDetails.id).addClass('d-none');
														$('#participant_stream'+userDetails.id).removeClass('d-none');
													}
												
												if ( currentUserData.sessionData.showOtherParticipants == 1 ) // && userDetails.isVisible 
													{
														subscribeToVideoStream(userDetails.id);
													}
											}
									}
							}
					}
			}
	
		if ( resultant[0] == 'feedFm' )
			{
				if ( resultant[1] == 'play' )
					{
						let nameValue = '';
						if ( resultant[3] )
							{
								nameValue = resultant[3];
							}
					
						rtm.invoke({'code': 75, 'func': 'play', 'param': resultant[2], 'name': nameValue});
					}
			}
			
		if ( resultant[0] == 'hideMemberFitness' )
			{
				if ( window['sessionStartedBeforeMemberJoin'] )
					{
						window['sessionStartedBeforeMemberJoin']();
					}
			}			
	}
	
	window.signalHandler = signalHandler;
	
	function arrowEventChange(opt){
		if ( remoteEvent == '' ) { return false; }
		
		if ( opt == 'left' )
			{
				if ( emojiesIndex !== 0 ) { emojiesIndex--; }
				$('.one_emoji').removeClass('highlight_emoji');
				$('#'+emojieIds[emojiesIndex]).addClass('highlight_emoji');
			}
			
		if ( opt == 'right' )
			{
				if ( emojiesIndex !== (emojieIds.length - 1) ) { emojiesIndex++; }
				$('.one_emoji').removeClass('highlight_emoji');
				$('#'+emojieIds[emojiesIndex]).addClass('highlight_emoji');
			}
			
		if ( opt == 'up' )
			{
				if ( remoteEvent == 'audioSettings' )
					{
						if ( microphoneIndex !== 0 ) { microphoneIndex--; }
						$('.drop_option').removeClass('highlight_option');
						$('.'+microphoneIds[microphoneIndex]).addClass('highlight_option');
					}
					
				if ( remoteEvent == 'videoSettings' )
					{
						if ( cameraIndexR !== 0 ) { cameraIndexR--; }
						$('.drop_option').removeClass('highlight_option');
						$('.'+cameraIds[cameraIndexR]).addClass('highlight_option');
					}
			}
			
		if ( opt == 'down' )
			{
				if ( remoteEvent == 'audioSettings' )
					{
						if ( microphoneIndex !== (microphoneIds.length - 1) ) { microphoneIndex++; }
						$('.drop_option').removeClass('highlight_option');
						$('.'+microphoneIds[microphoneIndex]).addClass('highlight_option');
					}
					
				if ( remoteEvent == 'videoSettings' )
					{
						if ( cameraIndexR !== (cameraIds.length - 1) ) { cameraIndexR++; }
						$('.drop_option').removeClass('highlight_option');
						$('.'+cameraIds[cameraIndexR]).addClass('highlight_option');
					}
			}
	}
	
	function remoteBack(){
		if ( remoteEvent == '' ) { return false; }
		
		if ( remoteEvent == 'emojies' )
			{
				$('.one_emoji').removeClass('highlight_emoji');
				emojiesIndex = 0;
				window['updateStateFromChild']({openReactions: false});
			}
			
		if ( remoteEvent == 'audioSettings' )
			{
				$('.drop_option').removeClass('highlight_option');
				microphoneIndex = 0;
				window['updateStateControls']({openAudioControls: false}); 
			}
			
		if ( remoteEvent == 'videoSettings' )
			{
				$('.drop_option').removeClass('highlight_option');
				cameraIndexR = 0;
				window['updateStateControls']({openVideoControls: false}); 
			}
			
		remoteEvent = '';
	}
	
	function confirmRemote(){
		if ( remoteEvent == '' ) { return false; }
		
		if ( remoteEvent == 'emojies' )
			{
				$('#'+emojieIds[emojiesIndex]).trigger('click');
			}
			
		if ( remoteEvent == 'audioSettings' )
			{
				$('.'+microphoneIds[microphoneIndex]).trigger('click');
			}
			
		if ( remoteEvent == 'videoSettings' )
			{
				$('.'+cameraIds[cameraIndexR]).trigger('click');
			}
	}
	
	window['checkDeviceForVirtual'] = function() 
		{
			if ( window['isFoundParEquipment'] && (!window['electron'] || android || ipad13) )
				{
					window['deviceNotSupported'] = true;
					var userId = JSON.parse(localStorage.getItem('userData')).id;
					setTimeout(function(){ window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'showVirtualError'+sep); }, 3000);
				}
			else
				{
					$('#virtualmsg').addClass('d-none');
					setTimeout(function(){ window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'hideVirtualError'+sep); }, 3000);
				} 
		}
	
    function channelMsgHandler(msg, senderId, userType, isFromReplay) {
		let res1    = msg.split(sep);
		let peerId  = null;
		let userDetails = null;

		if (senderId.includes("RM-") === false && !isFromReplay) {
          userDetails = collection.getDetailsByEmail(senderId);
          peerId      = userDetails.id;
		} else {
			if ( isFromReplay ) 
				{
					var hostWhiteboardId = currentUserData.sessionData.hostId != currentUserData.id ? currentUserData.sessionData.hostId : parseInt(JSON.stringify(currentUserData.sessionData.hostId)+'1000');
					window.hostWhiteboardId = hostWhiteboardId;
					
					userDetails = {'id': hostWhiteboardId};
				}

			peerId = senderId;
		}
		//console.log('channelMsgHandler', userDetails);
		//console.log('RES CHANNEL---', res1);
		
		if ( res1[0] == RTMConst.JOINED && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				//console.log('QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ');
				let addObject = null;
				let text      = RTMConst.WELCOME + sep + 0;
				
				sendMessage(senderId, text);
				
				if (senderId.includes("RM-") === false) {
					if (userDetails.userType == Const.USER_TYPE.HOST) {
						$('#onlinetext').text('ONLINE');
						$('#onlineicon').removeClass('d-none');
						$('#offlineicon').addClass('d-none');
						checkForMicCamPermission();
						currentUserData.sessionData.isHostOffline = 0;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
					}
				}
				
				var cameraDisableStatus = [];
				if ( localStorage.getItem('turnOfCamera') ) { cameraDisableStatus = JSON.parse(localStorage.getItem('turnOfCamera')); }
				if ( userDetails.userType == Const.USER_TYPE.HOST ) 
					{
						let myDetails = collection.getDetailsById(currentUserData['id']);
						let status = 0;
						if ( myDetails.broadcastVideoHost )
							{
								status = 1;
							}
						
						let text = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
						sendMessage(senderId, text);
					}
				else
					{
						let myDetails = collection.getDetailsById(currentUserData['id']);
						let status = 0;
						if ( myDetails.broadcastVideo )
							{
								status = 1;
							}
						
						let text = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
						sendMessage(senderId, text);
					}
			}
			
		if ( res1[0] == RTMConst.SESSION_COMPLETED && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				//session ended
				rtm.invoke({'code': 306});
			}
			
		if ( res1[0] == RTMConst.START_SCRIPT )
			{
				console.log('START_SCRIPT');
				var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
				
				console.log('START_SCRIPT workoutArray[0]', workoutArray[0]);
				if ( (workoutArray[0] && workoutArray[0]['attribute'][0]['attrValue'] != 'Pause' && workoutArray[0]['attribute'][0]['attrValue'] != 'Pause Virtual') || (window['virtualScriptStarted'] && !currentUserData.sessionData.ondemandId) )
					{
						window['scriptStarted'] = true;
						window.pauseVirtualActivityStarted = false;
								
						window['utcTimeMember'] = Util.getUTCTimestamp();
						
						if ( workoutArray[0]['attribute'][0]['attrValue'] == 'Virtual Equipment' && !window['virtualScriptStarted'] )
							{
								window['usingPose'] = true;
								
								if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] )
									{
										window['allowReadyGo'] = true;
										window['playCountdown'] = true;
										
										var virtualActivity = window.setNextActivityVirtual(0);
										
										window['userWhiteboard'][currentUserData.id].currentActivityName = virtualActivity;
										window['userWhiteboard'][currentUserData.id].activityStarted(virtualActivity);
										
										window.setNextActivityVirtual(0, 0);
									}
								
								if ( window.userCameraOff )
									{
										startPauseVirtualActivity(workoutArray[0]['name']);
									}
								else
									{
										$('#canvasWrap').removeClass('hostVirtualOnMember');
									}
								
								if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 )
									{
										window.setCurrentActivity();
									}
								else 
									{
										setTimeout(()=> {
											window.setCurrentActivity();
										}, 2000)
									}
							}
						else
							{
								window.setCurrentActivity();
							}
						
						window.setNextActivityParticipants('start');
						
						if ( !window['allowReadyGo'] ) { play_notification_sound(); }
						
						if ( window['preStreamingRoomSetup'+currentUserData.sessionData.hostId] && !window['userWhiteboard'][currentUserData.sessionData.hostId].roomSetup.workoutAreaSetupDone )
							{
								console.log('preStreamingWASLocation', window['preStreamingWASLocation'+userDetails.id]);
								console.log('loadPreWhiteboard 444');
								if ( !window['userWhiteboard'][currentUserData.sessionData.hostId] )
									{
										console.log('loadPreWhiteboard 5555');
										console.log('LOADED SCRIPT',currentUserData.sessionData.hostId);
										
										window['userWhiteboard'][currentUserData.sessionData.hostId] = new whiteboard({'user_id': currentUserData.sessionData.hostId});
										console.log('loadPreWhiteboard 666');
										window['load'+currentUserData.sessionData.hostId] = true;
									}
								console.log('loadPreWhiteboard 777');
								window['userWhiteboard'][currentUserData.sessionData.hostId].roomSetup.finishWorkoutSetupHost(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]);
								console.log('loadPreWhiteboard 888');
							}
					}
				else
					{
						let nextActivity = workoutArray[1];
						console.log('nextActivity start', nextActivity);
						if ( nextActivity ) 
							{
								if ( nextActivity['attribute'][0]['attrValue'] == 'Pause' || nextActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
									{
										nextActivity = workoutArray[2];
									}
								console.log('nextActivity2 start', nextActivity);
									
								if ( nextActivity && (nextActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || nextActivity['attribute'][0]['attrValue'] == 'Virtual Assistant') )
									{	
										var script_name = nextActivity['name'];
										window.setPauseVirtualActName(script_name);
										
										if ( currentUserData.sessionData.ondemandId > 0 ) { 
											window['utcTimeMember'] = Util.getUTCTimestamp();
											window.setCurrentActivity();
											window.setNextActivityParticipants('start');
										}
										
										if ( window['openParticipantList'] )
											{
												window['hideMembersOnVirtualActivity']();
												window['hideMemberOnVirtual'] = true;
											}
										
										if ( workoutArray[0]['attribute'][0]['attrValue'] == 'Pause' )
											{
												startPauseActivity(script_name);
											}
										else if ( workoutArray[0]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												startPauseVirtualActivity(script_name);
											}
											
										$('#canvasWrap').removeClass('d-none');
									}
							}
					}
				window['virtualScriptStarted'] = true;
			}
			
		if ( res1[0] == RTMConst.NEXT_SCRIPT )
			{
				var remainingTime = false;
				
				if ( res1[2] )
					{
						console.log('lastScriptCode', lastScriptCode, res1[2]);
						if ( lastScriptCode >= parseInt(res1[2]) && !currentUserData.sessionData.ondemandId )
							{
								return false; //do nothing, second time or previous code
							}
						
						lastScriptCode = res1[2];
					}
				
				if ( res1[3] && currentUserData.sessionData.ondemandId > 0 )
					{
						remainingTime = res1[3];
					}
				
				console.log("NEXT SCRIPT RTM");
				var nextAct = true;
				var pauseAct = undefined;
				let indexNum = 0;
				if ( res1[1] )
					{
						//pauseAct = JSON.parse(res1[2]);
						indexNum = JSON.parse(res1[1]);
					}
				
				if ( window.checkRTMtimeout )
					{
						clearTimeout(window.checkRTMtimeout);
					}
				
				if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout )
					{
						clearTimeout(window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout);
						window['userWhiteboard'][currentUserData.id].clearMessageInstructions();
						if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
					}
					
				let nextNum = indexNum + 1;	
				
				var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
		
				if ( workoutArray[indexNum] && workoutArray[indexNum]['attribute'][0]['attrValue'] != 'Pause' && workoutArray[indexNum]['attribute'][0]['attrValue'] != 'Pause Virtual' )
					{
						window['utcTimeMember'] = Util.getUTCTimestamp();
						$('#partBigCounter').addClass('d-none');
						$('.virtualDisabledMsg').addClass('d-none');
						if ( window['deviceNotSupported'+currentUserData.id] )
							{
								$('#virtualmsg').text('').addClass('d-none');
							}
						window['scriptStarted'] = true;
						window.isPaused = true;
						
						window.setNextActivityParticipants(nextNum);
						window.pauseVirtualActivityStarted = false;
						//setTimeout(function(){ $('#canvasWrap').removeClass('hostVirtualOnMember'); console.log('hostFlipRemove 222'); }, 100);
						
						if ( res1[1] && window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] && !window.userCameraOff )
							{
								var currentActIndex = parseInt(res1[1]);
								window['allowReadyGo'] = true;
								window['playCountdown'] = true;
								
								var virtualActivity = window.setNextActivityVirtual(currentActIndex);
								
								window['userWhiteboard'][currentUserData.id].currentActivityName = virtualActivity;
								window['userWhiteboard'][currentUserData.id].activityStarted(virtualActivity);
								
								window.setNextActivityVirtual(currentActIndex, 0);
								
								if ( window['userWhiteboard'][currentUserData.id].trackerActions.turnOffMediaPipe ) 
									{ 
										setTimeout(function() { window['userWhiteboard'][currentUserData.id].trackerActions.toggleMediaPipe(false); }, 1000);
									}
							}
							
						if ( workoutArray[indexNum] && workoutArray[indexNum]['attribute'][0]['attrValue'] == 'Virtual Equipment' )
							{
								window['usingPose'] = true;
								
								if ( window.userCameraOff )
									{
										startPauseVirtualActivity(workoutArray[indexNum]['name']);
									}
								
								nextActivityStartTimeout = setTimeout(function() {
									window.setCurrentActivity(nextAct, pauseAct, indexNum, remainingTime);
								}, 2000);
							}
						else
							{
								$('#canvasWrap').addClass('d-none');
								window.setCurrentActivity(nextAct, pauseAct, indexNum, remainingTime);
							}
					}
				else
					{
						let nextActivity = workoutArray[indexNum+1];
						console.log('nextActivity', nextActivity);
						if ( nextActivity ) 
							{
								if ( nextActivity['attribute'][0]['attrValue'] == 'Pause' || nextActivity['attribute'][0]['attrValue'] == 'Pause Virtual' )
									{
										nextActivity = workoutArray[indexNum+2];
									}
								console.log('nextActivity2', nextActivity);
									
								if ( nextActivity && (nextActivity['attribute'][0]['attrValue'] == 'Virtual Equipment' || nextActivity['attribute'][0]['attrValue'] == 'Virtual Assistant') )
									{	
										var script_name = nextActivity['name'];
										window.setPauseVirtualActName(script_name);
										
										if ( currentUserData.sessionData.ondemandId > 0 ) { 
											window['utcTimeMember'] = Util.getUTCTimestamp();
											window.setCurrentActivity(nextAct, pauseAct, indexNum, remainingTime);
											window.setNextActivityParticipants(nextNum);
										}
										
										if ( window['openParticipantList'] )
											{
												window['hideMembersOnVirtualActivity']();
												window['hideMemberOnVirtual'] = true;
											}
										
										if ( workoutArray[indexNum]['attribute'][0]['attrValue'] == 'Pause' )
											{
												startPauseActivity(script_name);
											}
										else if ( workoutArray[indexNum]['attribute'][0]['attrValue'] == 'Pause Virtual' )
											{
												startPauseVirtualActivity(script_name);
											}
										
										let pauseActivityDuration = workoutArray[indexNum]['attribute'][2]['attrValue'] * 1000;
											
										window.checkRTMtimeout = setTimeout(function() {
											var sep = '~@$';
											if ( window['globalRTM'] && currentUserData['sessionData'] ) { window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'checkActivityRTM'+sep); }
										}, pauseActivityDuration + currentUserData.default.nextActivityTimeout);
										
										$('#canvasWrap').removeClass('d-none');
									}
							}
					}
				
				//window['allowReadyGo'] = false;
			}
			
		if ( res1[0] == RTMConst.SYNC_WHEN_PAUSE_ACTIVITY && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				if ( window['setIndexNumAfterSync'] )
					{
						let num = parseInt(res1[1]) - 1;
						window['setIndexNumAfterSync'](num);
					}
			}	
			
		if ( res1[0] == RTMConst.PAUSE_SCRIPT )
			{
				window['scriptStarted'] = false;
				window.isPaused = true;
				window.pauseCurrentActivity();
				if ( nextActivityStartTimeout ) { clearTimeout(nextActivityStartTimeout); }
				if ( window.syncScriptTimeout ) { clearTimeout(window.syncScriptTimeout); }
				if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] ) { window['userWhiteboard'][currentUserData.id].doActivityEvents('activityPaused'); }
			}
			
		if ( res1[0] == "404" )
			{
				//window['allowReadyGo'] = true;
				window.setCurrentActivity();
				play_notification_sound();
			}
			
		if ( res1[0] == RTMConst.STOP_SCRIPT )
			{
				var paramMess = '';
				if ( currentUserData.sessionData.ondemandId > 0 )	
					{
						paramMess = 'act_end';
					}
				else
					{
						paramMess = 'stop_script';
					}
				if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] ) 
					{ 
						window['userWhiteboard'][currentUserData.id].doActivityEvents('activityEnded', paramMess); 
					}
				
				let stopAtEnd = res1[1];
				window['usingPose'] = false;
				window['scriptStarted'] = false;
				window['virtualScriptStarted'] = false;
				window.stopCurrentActivity();
				window.pauseVirtualActivityStarted = false;
				$('#canvasWrap').removeClass('hostVirtualOnMember');
				if ( nextActivityStartTimeout ) { clearTimeout(nextActivityStartTimeout); }
				if ( window.syncScriptTimeout ) { clearTimeout(window.syncScriptTimeout); }
				
				if ( stopAtEnd == 0 && window.stopFooterActivity )
					{
						window.stopFooterActivity();
						console.log('stopFooterActivity');
					}
				
				if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout )
					{
						clearTimeout(window['userWhiteboard'][currentUserData.id].trackerActions.mediaPipeToggleTimeout);
						window['userWhiteboard'][currentUserData.id].clearMessageInstructions();
						if ( window.disableCalculatingAR ) { window.disableCalculatingAR(); }
					}
				
				if ( currentUserData.sessionData.switchHostParticipant != undefined && currentUserData.sessionData.switchHostParticipant == 0 )
					{
						if ( window['streamSwapped'] && !window['deviceNotSupported'] && !window['userCameraOff'] ) { window.swapStreamVirtual(true); }
					}
			}
			
		if ( res1[0] == RTMConst.SYNC_SCRIPT && currentUserData.sessionData.replayClassId == 0  && !currentUserData.sessionData.ondemandId )
			{
				window['scriptStarted'] = true;
				syncParticipantScript(res1);	
			}
			
		if ( res1[0] == RTMConst.UNMUTE_BROADCASTER_OTHER_PARTICIPANT )
			{
				if ( hostStreamMuted == false )
					{
						let speakerIds = res1[1].split(',');
							streamArray.forEach((stream)=>{
								if ( stream.getId() != undefined && speakerIds.indexOf(stream.getId().toString()) > -1 ) 
									{
										stream.unmuteAudio();
									}
							});
					}
				else 
					{
						window['muteSpeaker']();
					}					
			}
		
		if ( res1[0] == RTMConst.MUTE_BROADCASTER_OTHER_PARTICIPANT )
			{
				let receiverId = res1[1];
				if ( currentUserData.id != receiverId )
					{
						 muteParticipantAudio(receiverId);
					}
				streamArray.forEach((stream)=>{
								if ( stream.getId() != undefined && receiverId == stream.getId() ) 
									{
										stream.muteAudio();
									}
							});	
			}		
		
		if ( res1[0] == RTMConst.PLAY_PLAYLIST )
			{
				$('#playlist_participant').removeClass('d-none');
				$('#songname').text(res1[1]);
				$('#songartist').text(res1[2]);
			}
			
		if ( res1[0] == RTMConst.STOP_PLAYLIST )
			{
				$('#playlist_participant').addClass('d-none');
			}
			
		if ( res1[0] == RTMConst.CHAT && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId ) 
			{
				if( senderId.includes("RM-") ) 
					{
						senderId = senderId.split('RM-')[1];
					}

				let userDetails = collection.getDetailsByEmail(senderId);
				window.onReceiveMessage(userDetails, res1[1], "channel", res1[2]);
				
				if ( $('#chat_menu').css('display') == 'none' )
					{
						var messagesCounter = $('#chat_counter').text();
						messagesCounter++;
						$('#chat_counter').text(messagesCounter);
						$('#chat_counter').removeClass('d-none');
						localStorage.setItem('unreadMessagesNum', messagesCounter);
						localStorage.setItem('unreadMessagesClassId', currentUserData.sessionData.id);
					}
				window['showAllElements']();	
			}
			
		if ( res1[0] == RTMConst.SWITCH_VIDEO_BROADCAST ) 
			{
				console.log('SWITCH_VIDEO_BROADCAST channelMessageHandler ------------------');
				let status = false;
				if (res1[1] == 1) {
					status = true;
				}
				
				let userDetails = collection.getDetailsByEmail(senderId);
				let updateObject = {"broadcastVideo": status};
				collection.updateModel(userDetails.id, JSON.stringify(updateObject));
				addUserAttribute(userDetails.id, 'broadcastVideo', status);
				
				if ( res1[2] && res1[2] == 1)
					{
						let myDetails = collection.getDetailsById(currentUserData['id']);
						let status = 0;
						if ( myDetails.broadcastVideo )
							{
								status = 1;
							}
						
						let text = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
						sendMessage(senderId, text);
					}
				
				if (window['openParticipantList'])
					{
						if ( usersOnScreenCurrent && usersOnScreenCurrent.length > 0 )
							{
								if ( usersOnScreenCurrent.indexOf(userDetails.id) > -1 )
									{
										if ( res1[1] == 0 )
											{
												console.log(0);
												console.log(userDetails.isVisible);
												$('#nocam'+userDetails.id).removeClass('d-none');
												$('#participant_stream'+userDetails.id).addClass('d-none');
												
												if ( currentUserData.sessionData.showOtherParticipants == 1 ) //&& userDetails.isVisible
													{
														subscribeToAudioOnlyStream(userDetails.id);
													}
											}
										else
											{
												console.log(1);
												console.log(userDetails.isVisible);
												if ( userDetails.id !== currentSharedUser )
													{
														$('#nocam'+userDetails.id).addClass('d-none');
														$('#participant_stream'+userDetails.id).removeClass('d-none');
													}
												
												if ( currentUserData.sessionData.showOtherParticipants == 1 ) // && userDetails.isVisible 
													{
														subscribeToVideoStream(userDetails.id);
													}
											}
									}
							}
					}
			}

		if ( res1[0] == RTMConst.UNMUTE_ALL && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				if ( isMutedByMe ) 
					{
						let text = RTMConst.PARTICIPANT_MUTED_SELF + sep + currentUserData.id;
						sendMessage(senderId, text);
						$('#raise_hand').addClass('d-none');
						rtm.invoke({'code': RTMConst.UNMUTE_ALL});
						currentUserData.sessionData.isHiddenRaiseHand = 1;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
						return false; 
					}
				
				let showMsg = true;
				if ( $('.audio_icon .muted_audio').is(":hidden") ) { showMsg = false; }
				
				//unmute all mics
				
				currentUserData.unmuteAllEnabled = true;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				currentUserData = currentUserData;
				
				if ( hostStreamMuted === false ) { unmuteParticipantAudio(); }
				localStream.unmuteAudio();
				
				$('#microphone_control').text('Mute Microphone');
				$('.audio_icon .muted_audio').addClass('d-none');
				$('#mic_control .muted_audio').addClass('d-none');
				$('#raise_hand').addClass('d-none');
				currentUserData.sessionData.isHiddenRaiseHand = 1;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				$('#mic_control').removeClass('d-none');
				//$('#speak_control').removeClass('d-none'); 
					
				
				if ( showMsg ) { rtm.invoke({'code': RTMConst.UNMUTE_ALL}); }
			}
			
		if ( res1[0] == RTMConst.MUTE_ALL && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				if ( isMutedByMe )
					{ 
						$('#raise_hand').removeClass('d-none');
						rtm.invoke({'code': RTMConst.MUTE_ALL});
						currentUserData.sessionData.isHiddenRaiseHand = 0;
						localStorage.setItem('userData', JSON.stringify(currentUserData));
						return false; 
					}
				
				let showMsg = true;
				if ( $('.audio_icon .muted_audio').is(":visible") ) { showMsg = false; }
				
				//mute all mics
				
				currentUserData.unmuteAllEnabled = false;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				currentUserData = currentUserData;

				localStream.muteAudio();
				
				if ( hostStreamMuted === false ) 
					{
						streamArray.forEach((stream) => {
							if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
								{
									stream.muteAudio();
								}
						});
					}
					
				$('#microphone_control').text('Unmute Microphone');
				$('.audio_icon .muted_audio').removeClass('d-none');
				$('#mic_control .muted_audio').removeClass('d-none');
				$('#raise_hand').removeClass('d-none');
				currentUserData.sessionData.isHiddenRaiseHand = 0;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				
				if ( showMsg ) { rtm.invoke({'code': RTMConst.MUTE_ALL}); }
			}
			
		if ( res1[0] == RTMConst.SHOW_SESSION_RECORDING_ICON && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				if ( res1[1] == 1 )
					{
						$('#record_info').removeClass('d-none');
					}
				else
					{
						$('#record_info').addClass('d-none');
					}
			}
		if ( res1[0] == RTMConst.HOST_JOINED && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				//console.log('JOINED HOST AGAIN!!!');

				$('#onlinetext').text('ONLINE');
				$('#onlineicon').removeClass('d-none');
				$('#offlineicon').addClass('d-none');
				checkForMicCamPermission();
				currentUserData.sessionData.isHostOffline = 0;
				localStorage.setItem('userData', JSON.stringify(currentUserData));

				if ( $('#speaker_control').text() == 'Unmute Speaker' )
					{
						//console.log('SPEAKER IS MUTED');
						mutedOtherParticipants = true;
						hostStreamMuted = true;
					}

				rtm.invoke({'code': RTMConst.HOST_JOINED});
			}
			
		if ( res1[0] == RTMConst.SETTINGS )
			{
				let state = parseInt(res1[1]);
				currentUserData.sessionData.showOtherParticipants = state;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				if ( state == 1 )
					{
						/* for ( let i = 0; i<usersOnScreenCurrent.length; i++ )
							{
								if ( usersOnScreenCurrent[i] )
									{
										var userDetailsStream = collection.getDetailsById(usersOnScreenCurrent[i]);
										if ( userDetailsStream ) //&& userDetailsStream.broadcastVideo !== false
											{
												subscribeToVideoStream(userDetailsStream['id']);
											}
									}
							} */
						$('#participants_streams').removeClass('d-none');
						window['showOtherParticipants'] = true;
					}
				else
					{
						for ( let i = 0; i<usersOnScreenCurrent.length; i++ )
							{
								if ( usersOnScreenCurrent[i] )
									{
										subscribeToAudioOnlyStream(usersOnScreenCurrent[i]);
										let userDetails = collection.getDetailsById(usersOnScreenCurrent[i]);
										if ( userDetails.broadcastVideo == false )
											{
												$('#participant_stream'+userDetails.id).addClass('d-none');
												$('#nocam'+userDetails.id).removeClass('d-none');
											}
									}
							}
						$('#participants_streams').addClass('d-none');

						window['showHideStream']();
						window['showOtherParticipants'] = false;

					}
					
				rtm.invoke({'code': 302, 'state': state});
			}

		if ( res1[0] == 'hostStartedEquipmentFalse' ) 
			{
				window['hostStartedEquipment'+currentUserData.id] = false;
			}
			
		if ( res1[0] == 'highlightParticipant' ) 
			 {
				console.log('highlightParticipant streamingController**********************');
				if ( parseInt(res1[1]) !== currentUserData.id )
					{
						console.log(window['streamSwapped'], 'shareStream swapped');
						window['shareAllStarted'] = true;
						shareAllUser = parseInt(res1[1]);
						
						$('#canvasUser').html('');
						$('#canvasUser').append('<canvas id="highlightCanvas" className="highlight_canvas highlightCanvas highlightCanvasDraw" width="1280" height="720"></canvas><canvas id="highlightGridCanvas" className="highlight_canvas highlightCanvas" width="1280" height="720"></canvas><canvas id="highlightVideoCanvas" className="highlight_canvas highlightCanvas" width="1280" height="720"></canvas>');
						
						if ( window['streamSwapped'] )
							{
								console.log('highlightParticipant 111');
								//swapStreamVirtual(false, true, true, false, false);
								
								window.setShareAll(1, parseInt(res1[1]));
								
								setTimeout(function(){
									highlightParticipant(parseInt(res1[1]));
								}, 1500);
							}
						else
							{
								console.log('highlightParticipant 222');
								//swapStreamVirtual(true, true, true, false, false);
								window.setShareAll(1, parseInt(res1[1]));
								
								setTimeout(function(){
									highlightParticipant(parseInt(res1[1]));
								}, 1500);
							}
					}
			}
			
		if ( res1[0] == 'removeHighlight' ) 
			{
				removeHighlight(res1[1], res1[2]);
			}
			
		if ( res1[0] == 'pauseBeforeEquipment' ) 
			{
      			pauseBeforeEquipment(res1[1], res1[2], res1[3]);
      		}
			
		if ( res1[0] == 'checkRoomSetup' ) {
    			var roomSetup = false;
    			if ( window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured ) { roomSetup = true; }
    			sendMessage(currentUserData.sessionData.hostEmail, 'roomSetupCompleted'+sep+roomSetup);
    		}
	
		if ( res1[0] == 'removeEquipmentDirections' ) 
			{
				if ( window['deviceNotSupported'] || window['userCameraOff'] || !window['userWhiteboard'][currentUserData.id] ) { return false; }
				
				window['userWhiteboard'][currentUserData.id].doActivityEvents('activityStarting');
				
				  window['showParticipantDirections'] = false;
				  window['soundPlay'].stopAudio();
				  $('.participant_stats_hold').removeClass('d-none');
				  window['playedInstructions'+currentUserData.id] = false;
				  $('#partToolTip').addClass('d-none');
				  $('.walk_tool_image').css('background-image', 'none');
				  $('#walkToolImage').addClass('d-none');
				  $('.walk_tool_text').html('');
				$('#partToolTip .tooltipText').html('');
				$('#upNextText').addClass('d-none');
				$('#upNextText').html('');
				$('#partToolTip .part_inner').html('');
			}
		
		if ( res1[0] == RTMConst.SEND_EMOJI )
			{
				let category = 'fitness';
			  
				let userDetails = collection.getDetailsByEmail(senderId);
				animateEmojis(res1[1], userDetails.firstName, category);
				play_emoji_notification_sound();
			}
			
		if ( res1[0] == RTMConst.SWITCH_HOST_PARTICIPANT )
			{
				let state = parseInt(res1[1]);
				currentUserData.sessionData.switchHostParticipant = state;
				localStorage.setItem('userData', JSON.stringify(currentUserData));
				
				if ( state == 1 && !window['streamSwapped'] )
					{
						swapStreamVirtual(false, true, true, 'pip');
					}
					
				if ( state == 0 && window['streamSwapped'] )
					{
						swapStreamVirtual(true, true, true, 'pip');
					}
			}
			
		if ( res1[0] == RTMConst.SYNC_MANUAL && currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
			{
				setTimeout(function() {
					$('#workout_progress').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 100;'});
					$('#workoutTimer').text("00:00");
					
					pauseActivity(res1[1]);
				}, 1000);
			}
		if ( res1[0] == RTMConst.SESSION_STARTED )
			{
				//$('#hostNoVideo').addClass('d-none');
				if ( window['sessionStartedBeforeMemberJoin'] )
					{
						window['sessionStartedBeforeMemberJoin']();		
					}
			}
			
		if ( res1[0] == RTMConst.REMOTE_ZOOM_HOST )
			{
				$('#zoom_option').trigger('click');
			}

		if ( res1[0] == 'waitBeforeDraw' )
			{
				window['waitBeforeDraw'] = true;
			}			
			
		if ( res1[0] == 'pauseActivityOnStart' )
			{
				console.log('pauseActivityOnStart 000');
				var currentActIndex = parseInt(res1[1]);
				var previousAcitivty = JSON.parse(res1[2]);
				window['allowReadyGo'] = true;
				window['playCountdown'] = true;
				
				console.log('pauseActivityOnStart 111');
				var virtualActivity = window.setNextActivityVirtual(currentActIndex);
				console.log('pauseActivityOnStart 222');
				
				window['userWhiteboard'][currentUserData.id].currentActivityName = virtualActivity;
				window['userWhiteboard'][currentUserData.id].activityStarted(virtualActivity);
				
				console.log('pauseActivityOnStart 333');
				window.setNextActivityVirtual(currentActIndex, previousAcitivty);
			}
			
		if ( res1[0] == 'feedFm' )
			{
				let nameValue = '';
				if ( res1[3] )
					{
						nameValue = res1[3];
					}
					
				if ( res1[1] == 'play' )
					{
						rtm.invoke({'code': 75, 'func': 'play', 'param': res1[2], 'name': nameValue});
					}
					
				if ( res1[1] == 'stop' )
					{
						rtm.invoke({'code': 75, 'func': 'stop'});
					}
					
				if ( res1[1] == 'mute' )
					{
						let muteStatus = JSON.parse(res1[2].toLowerCase());
						window['instructorMutedFm'] = muteStatus;
						if ( muteStatus == true )
							{	
								if ( window['hideVolumeBarAtMember'] )
									{
										window['hideVolumeBarAtMember']();
									}
								
							}
						rtm.invoke({'code': 75, 'func': 'mute', 'param': res1[2]});
					}
			}
			
		if ( res1[0] == 'pauseActivityStarted' )
			{
				var script_name = res1[1];
				
				if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] )
					{
						if ( !window['streamSwapped'] )
							{
								swapStreamVirtual(false);
							}
							
						window.pauseVirtualActivityStarted = false;
						
						$('#canvasWrap').removeClass('d-none');
						$('#canvasWrap').removeClass('hostVirtualOnMember');
						window['userWhiteboard'][currentUserData.id].activityStarted(script_name);
						window['userWhiteboard'][currentUserData.id].currentActivityName = script_name;
					
						window.setPauseVirtualActName(script_name);
					
						if ( window['openParticipantList'] )
							{
								window['hideMembersOnVirtualActivity']();
								window['hideMemberOnVirtual'] = true;
							}
						
					}
			}
			
		if ( res1[0] == 'pauseVirtualActivityStarted' )
			{
				if ( window['streamSwapped'] )
					{
						swapStreamVirtual(true);
					}
				
				var script_name = res1[1];
				
				window['updateStateFromChild']({openMyStream: false});
				if ( !window['showAllElementsStatus'] )
					{
						$('#mine_stream').addClass('opacityHide');
					}
			
				if ( window['openParticipantList'] )
					{
						window['hideMembersOnVirtualActivity']();
						window['hideMemberOnVirtual'] = true;
					}	
				
				if ( !window['userWhiteboard'][currentUserData.sessionData.hostId] )
					{
						window['userWhiteboard'][currentUserData.sessionData.hostId] = new whiteboard({'user_id': currentUserData.sessionData.hostId, 'host_virtual_member': true});
						window['load'+currentUserData.sessionData.hostId] = true;
					}
				
				window.changeGlobalActType('', currentUserData.id);
				
				window.pauseVirtualActivityStarted = true;
				
				console.log('pauseVirtualActivityStarted script_name');
				console.log(script_name);
				
				window.setPauseVirtualActName(script_name);
				
				window['userWhiteboard'][currentUserData.sessionData.hostId].currentActivityName = script_name;
				
				if ( window['preStreamingRoomSetup'+currentUserData.sessionData.hostId] && !window['userWhiteboard'][currentUserData.sessionData.hostId].roomSetup.workoutAreaSetupDone )
					{
						console.log('preStreamingWASLocation', window['preStreamingWASLocation'+userDetails.id]);
						window['userWhiteboard'][currentUserData.sessionData.hostId].roomSetup.finishWorkoutSetupHost(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]);
						console.log('loadPreWhiteboard 888');
					}
					
				var workoutZone = {};
				if ( window['preStreamingWASLocation'+currentUserData.sessionData.hostId] && !hostZoneSet )
					{
						let gridZoneObj = {
							'x1': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['topRight']['posX']),
							'x2': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['topLeft']['posX']),
							'x3': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['bottomRight']['posX']),
							'x4': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['bottomLeft']['posX']),
							'y1': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['topRight']['posY']),
							'y2': parseInt(window['preStreamingWASLocation'+currentUserData.sessionData.hostId]['bottomRight']['posY']),
							'columns': 5,
							'rows': 3
						};
						console.log('pauseVirtualActivityStarted gridZoneObj', gridZoneObj);
						if ( window.gridZoneUpdate ) { console.log('pauseVirtualActivityStarted gridZoneUpdate'); window.gridZoneUpdate(JSON.stringify(gridZoneObj), parseInt(userDetails.id)); hostZoneSet = true; }
					}	
				
				window['userWhiteboard'][currentUserData.sessionData.hostId].activityStarted(script_name);
				
				$('#canvasWrap').addClass('hostVirtualOnMember').removeClass('d-none');
				$('#participant_activity').removeClass('d-none');
				$('#time_counter').removeClass('d-none');
				
				console.log('pauseVirtualActivityStarted 222');
			}
			
		if ( res1[0] == 'modifyGlobalObject' ) 
			{
				let activityObject = res1[1];
				let activityName = res1[2];
				
				console.log('modifyGlobalObject id', userDetails.id);
				console.log(activityName, 'activityNameGetting');
				if ( window['userWhiteboard'][userDetails.id] ) 
					{
						var currentObject = window['userWhiteboard'][userDetails.id].activityBuilderContent.activityBuilderObject;
						window['getCurrentObjectInnit'] = activityObject;
						
						if ( activityName == 'reset' || activityName == '' ) { window['userWhiteboard'][userDetails.id].changeGlobalObject(JSON.stringify(currentObject[activityName]), activityName);  }
						else { window['userWhiteboard'][userDetails.id].changeGlobalObjectRTM(activityObject, activityName); }
					}
			}
			
		if( res1[0] == "modifyCustomVariable" ) 
			{
				let customObject = JSON.parse(res1[1]);
				console.log('modifyCustomVariable RTM received', customObject);
				if ( window.setCustomObject ) { window.setCustomObject(customObject[0], customObject[1], customObject[2], userDetails.id);  console.log('modifyCustomVariable function called'); }
			}
			
		if( res1[0] == "startWAS" ) 
			{
				if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].activityStarted('Workout Area Setup'); }
			}
			
		if( res1[0] == "updateGridZone" ) 
			{
				let gridZoneObject = JSON.parse(res1[1]);
				console.log('gridZoneObject', gridZoneObject);
				
				//if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].gridActions.setGridZone(gridZoneObject['x1'], gridZoneObject['x2'], gridZoneObject['x3'], gridZoneObject['x4'], gridZoneObject['y1'], gridZoneObject['y2'], gridZoneObject['columns'], gridZoneObject['rows']); }
				if ( window.gridZoneUpdate ) { window.gridZoneUpdate(res1[1], parseInt(userDetails.id)); if ( window['setDetectors'] ) { window['setDetectors'](parseInt(userDetails.id)); } }
			}
		
		if ( res1[0] == 'preStreamingRoomSetup' )
			{
				window['preStreamingRoomSetup'+userDetails.id] = true;
				window['preStreamingWASLocation'+userDetails.id] = JSON.parse(res1[1]);
			}
		
		if ( res1[0] == 'finishWorkoutSetup' )
			{
				if ( window['userWhiteboard'][userDetails.id] )
					{
						window['userWhiteboard'][userDetails.id].roomSetup.finishWorkoutSetupHost(JSON.parse(res1[1]));
						
						if ( window['userWhiteboard'][userDetails.id].currentActivityName != '' )
							{
								window['userWhiteboard'][userDetails.id].activityStarted(window['userWhiteboard'][userDetails.id].currentActivityName);
							}
					}
			}
			
		if( res1[0] == "changeGlobalCounter" ) 
			{
				if ( window['userWhiteboard'][userDetails.id] ) { window['userWhiteboard'][userDetails.id].changeGlobalCounter(res1[1], res1[2]); }
				console.log('userDetails---', userDetails.id);
				console.log('peerId---', peerId);
				console.log('changeGlobalCounter---', senderId);
				
				let user = collection.getDetailsByEmail(senderId);
				console.log('getDetailsByEmail---', user);
				var maximum1 = 0;
				if ( res1[3] )
					{
						//var userCounter = parseInt($("#score"+user.id).html()) + parseInt(res1[3]);
						//$("#score"+user.id).html(userCounter);
						if ( participantsInStream )
							{
								console.log('participantsInStream', participantsInStream);
								for( var i = 0; i < participantsInStream.length; i++ )
									{
										if ( participantsInStream[i].userId == user.id )
											{
												console.log('participantsTrueeee',participantsInStream[i].counter);
												userCounter = participantsInStream[i].counter + parseInt(res1[3]);
												console.log('participantsneeeew',participantsInStream[i].counter);
											}
										
										/*if ( participantsInStream[i].userId == currentUserData.id )
											{
												console.log('participantsTrueeee',participantsInStream[i].counter);
												userCounter2 = participantsInStream[i].counter + 1;
												console.log('participantsneeeew',participantsInStream[i].counter);
											}*/
										
											
										if ( participantsInStream[i].counter > maximum1 )
											{
												maximum1 = participantsInStream[i].counter;
											}
									}
							}
					}
				console.log('maximum1', maximum1);
				var maximum = 0;
				$(".holder_result").each(function() {
				  var value = parseFloat($(this).html());
				  maximum = (value > maximum) ? value : maximum;
				});
				
				$("#someonesPersBest").html(maximum1);
				
				countParticipants();
			}
			
		if ( res1[0] == 'changeBoxingPosition' ) 
			{
				if ( window['userWhiteboard'][userDetails.id] && window.updateBagPosition ) { window.updateBagPosition(parseInt(userDetails.id), res1[2]); }
			}
	}
	
	function play_notification_sound() {
		notification.play();
	}
	
	function play_emoji_notification_sound() {
		emojiNotification.play();
	}
	
	window.channelMsgHandler = channelMsgHandler;
	
	 function subscribeToAudioOnlyStream(userId){
      console.log('subscribeToAudioOnlyStream - ', userId);

      streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && stream.getId() == userId ) {

				if ( window['electron'] ) {
					//console.log('electron stream.muteVideo');
					stream.muteVideo();
				} else {
					//console.log('else electron');
					if ( !safari ) 
					{
						client.unsubscribe(stream, function(err) {
							//console.log('unsubscribe error - ', err);
						});

						stream.stop();

						client.subscribe(stream, {video: false, audio: true});
					}
				}
			}
		});
	}
	
	function subscribeToVideoStream(userId){
      console.log('subscribeToVideoStream - ', userId);

      streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && stream.getId() == userId ) {

				if ( window['electron'] ) {
					stream.unmuteVideo();
				} else {
					if ( !safari )
					{
						client.unsubscribe(stream, function(err) {
							//console.log('unsubscribe error - ', err);
						});

						stream.stop();

						client.subscribe(stream);
					}
				}
			}
		});
	}
	
	function unmuteParticipantAudio(id) {
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && ( stream.getId() == id || id == undefined ) )
				{
				  stream.unmuteAudio();
				}
		});
	}
	
	function syncParticipantScript(result){
		//console.log('SYNC SCRIPT---', result);
		var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
		
		for ( let i = 0; i < workoutArray.length; i++ )
			{
				if ( workoutArray[i]['attribute'][0]['attrValue'] == 'Pause' || workoutArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
					{
						workoutArray.splice(i, 1);
						i--;
					}
			}
		
		var resultantIndex = 0;
		if ( result[2] )
			{
				resultantIndex = parseInt(result[2] - 1);
				window.currentIndex = resultantIndex;
				if ( window['setNextIndexNum'] ) 
					{ 
						window['setNextIndexNum'](parseInt(result[2]));
					}
			}
		
		let countDown = parseInt(result[3]);
		let utcTimestamp = Util.getUTCTimestamp();
		let hostTimestamp = result[4];
		var syncActivity = activityArray[resultantIndex];
		var seconds = ( utcTimestamp - hostTimestamp );
		if ( seconds > 0 )
			{
				countDown = countDown + seconds;
				if ( countDown < 0 ) { countDown = 0; }
			}
			
		let timeRemaining = null;
		
		if ( syncActivity.attribute[1] && syncActivity.attribute[1].attrValue === 'Reps' )
			{
				var totalTime = parseInt(syncActivity.attribute[3].attrValue) * parseInt(syncActivity.attribute[9].attrValue);
				timeRemaining = totalTime - countDown;
			}
			
		if ( syncActivity.attribute[1] && syncActivity.attribute[1].attrValue === 'Time' )
			{
				timeRemaining = parseInt(syncActivity.attribute[2].attrValue) - countDown;
			}
		
		if ( result[1] == 1 )
			{
				//playing
				console.log('setCurrentIndexAndPlay sync', resultantIndex);
				window.setCurrentIndexAndPlay(resultantIndex, timeRemaining, utcTimestamp);
				window.setNextActivitySync(resultantIndex);
			}
			
		if ( result[1] == 2 )
			{
				//paused
				
				if ( syncActivity.attribute[1] && syncActivity.attribute[1].attrValue === 'Reps' )
					{
						var totalTime = parseInt(syncActivity.attribute[3].attrValue) * parseInt(syncActivity.attribute[9].attrValue);
						timeRemaining = totalTime - parseInt(result[3]);
					}
					
				if ( syncActivity.attribute[1] && syncActivity.attribute[1].attrValue === 'Time' )
					{
						timeRemaining = parseInt(syncActivity.attribute[2].attrValue) - parseInt(result[3]);
					}
				
				window.setNextActivitySync(resultantIndex);
				
				if ( result[6] && JSON.parse(result[6]) == true )
					{
						window.setCurrentIndexAndPause(resultantIndex, timeRemaining, true);
					}
				else
					{
						window.setCurrentIndexAndPause(resultantIndex, timeRemaining);
					}
			}
			
		if ( result[1] == 3 )
			{
				//ended
				window.stopFooterActivity(true);
				window.showActivityEnded();
			}
	}
	
	window.onChannelMessage = (message, senderId, isFromReplay) => {
      console.log('Channel Message - ', message, senderId);
	  if ( !window.pendingUsers ) { window.pendingUsers = []; } 

      let remoteUser = senderId.includes("RM-");

      if (remoteUser === false && !isFromReplay) {
		  let userExists = checkSessionUser(senderId);

          if (userExists === true) {              
              channelMsgHandler(message.text, senderId, currentUserData.userType);
          } else {
              if ( window.pendingUsers.length > 0) {
                  let senderExists = false;

                  window.pendingUsers.forEach((user)=>{
                      if (user.senderId == senderId) {
                          senderExists = true;
                      }
                  });

                  if (senderExists === false) {
                      let usertData = {"senderId": senderId, "message": message};
                      window.pendingUsers.push(usertData);
                  }
              } else {
                  let usertData = {"senderId": senderId, "message": message};
                  window.pendingUsers.push(usertData);
              }
          }
      } else {
		  channelMsgHandler(message.text, senderId, currentUserData.userType, true);
      }
  }
  
	window.unmuteParticipantVideo = () => {
		//console.log('unmuteParticipantVideo');
		streamArray.forEach((stream)=>{
			if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
				{
					let userDetails = collection.getDetailsById(stream.getId());
					//console.log('userDetails');
					//console.log(userDetails);
					if ( userDetails && userDetails.broadcastVideo )
						{
							if ( userDetails.isVisible === false ) 
								{
									let updateObject = {"subscribeTime": Util.getCurrentTimestamp() - 60000};
									collection.updateModel(stream.getId(), JSON.stringify(updateObject)); 
								}
								
							if ( window['electron'] )
								{
									//console.log('stream.unmuteVideo');
									stream.unmuteVideo();
								}
							else
								{
									client.unsubscribe(stream, function(err) {});
									stream.stop();
									client.subscribe(stream);
								}
						}
				}
		});
	}
	
	window.muteParticipantVideo = (userData = null) => {
		//console.log('muteParticipantVideo');
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && stream.getId() != currentUserData.sessionData.hostId )
				{
					let userDetails = collection.getDetailsById(stream.getId());
					//console.log('userDetails');
					//console.log(userDetails);
					if ( userDetails && userDetails.broadcastVideo )
						{
							if ( window['electron'] )
								{
									//console.log('stream.muteVideo');
									stream.muteVideo();
								}
							else
								{
									client.unsubscribe(stream, function(err) { });
									stream.stop();
									client.subscribe(stream, {video: false, audio: true});
								}
								
							let updateObject = {"isVisible": false, "subscribeTime": Util.getCurrentTimestamp()};
							collection.updateModel(stream.getId(), JSON.stringify(updateObject));
						}
				}
		});
	}
  
	function muteParticipantAudio(id) {
		streamArray.forEach((stream) => {
			if ( stream.getId() != undefined && ( stream.getId() == id || id == undefined ) ) 
				{
				  stream.muteAudio();
				}
		});
	}
	
	function getLocalStats() {
		
		var checkStarted = false;
      setInterval(function(){
		  if ( checkStarted && window['electron'] ) 
			{
				return false;
			}
		  checkStarted = true; 
          localStream.getStats((stats) => {
			  //console.log(`Local Stream AD: ${stats.accessDelay} PL: ${stats.videoSendPacketsLost} FR: ${stats.videoSendFrameRate} W: ${stats.videoSendResolutionWidth}, H: ${stats.videoSendResolutionHeight}`);
              let statValue = Util.getLocalStatsValue(stats.accessDelay);

              localStats.push(statValue);
              if (localStats.length == 5) {

                  var statsMean = Util.calculateAccessDelayMean(localStats);  
                  console.log(`Function - getLocalStats(), last 5 local stats: ${localStats} Mean: ${statsMean}`);
                  
                  if (previousNetworkQuality != statsMean) {
                      previousNetworkQuality = statsMean;
                      setVideoConfiguration(statsMean);

                      networkQualityArray.push(statsMean);

                      if (networkQualityArray.length == 10) {
                          let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "network", "userId": currentUserData.id, "details": JSON.stringify({"action":"networkQuality", "value": networkQualityArray}), "timestamp": Util.getCurrentTimestamp()};
                          sessionDataStore.addSessionData(addObject);

                          networkQualityArray = [];
                      }
                  }

                  localStats.splice(0, 1);
              }
		  });
	  }, localStatsTimer);
  }
  
	function setVideoConfiguration(networkQuality){
		if ( networkQuality < 3)
			{
				let showStatus = $('#participants_streams').hasClass('d-none');
				if (!showStatus && window['openParticipantList'] )
					{
						$('#participantsStreamList').trigger('click');
						streamClosedNetworkIssue = true;
					}
				$('#disable_streams').removeClass('d-none');
				$('.networkMsgHolder').removeClass('d-none');
				$('#numDisplayed').addClass('d-none');
				$('#poorNetworkMsgMembers').removeClass('d-none');				
				window['memberPoorNetworkIssue'] = true;	
			}
		else 
			{
				$('.networkMsgHolder').addClass('d-none');
				$('#numDisplayed').removeClass('d-none');
				$('#poorNetworkMsgMembers').addClass('d-none');
				$('#disable_streams').addClass('d-none');
				if ( streamClosedNetworkIssue )
					{
						$('#participantsStreamList').trigger('click');
					}
				streamClosedNetworkIssue = false;	
				window['memberPoorNetworkIssue'] = false;		
			}			
	}
  
	updateHeartRate(currentUserData.id, currentUserData.email, function(hrreturn) {
		//console.log('mobile heart rate --- ', hrreturn);

		if (hrreturn['heartRate'] != userHeartRate) 
			{
				userHeartRate = hrreturn['heartRate'];

				let text = RTMConst.BPM_HEART_RATE + sep + hrreturn['heartRate'];
				sendMessageToChannel(text);
			}

		setBPMAtParticipant(hrreturn);
	});
	
	function setBPMAtParticipant(signalData){
        if( signalData['heartRate'] ) { $('#heartrate').text(parseInt(signalData['heartRate'])); }
        if( signalData['calories'] ) { $('#calories').text(parseInt(signalData['calories'])); }
        if( signalData['vo2'] ) { $('#vo2max').text(parseInt(signalData['vo2'])); }

		sendMessage(currentUserData.sessionData.hostEmail, 'heartRateUpdate'+sep+JSON.stringify(signalData));
    }
	
	function zoomParticipant(par){
		
		var currentStream;
		
		if ( window['streamSwapped'] )
			{
				streamArray.forEach((stream)=>{
					if ( stream.streamId == currentUserData.sessionData.hostId )
						{
							currentStream = stream;
						}
					})
			}
		else 
			{
				if ( !cameraKeyNum )
					{
						currentStream = localStream;
					}
				else 
					{
						let numKey = parseInt(cameraKeyNum);
						currentStream = cameraStreams[numKey];
					}					
				
			}
			
			
		if ( par == 1 )
			{
				window['partZoomedIn'] = true;
				$('#zoomed_part').removeClass('d-none');
				currentStream.stop();
				if ( !window['streamSwapped'] )
					{
						
						for( let i in cameraStreams )
							{
								cameraStreams[i].stop();
							}
							
						if ( cameraKeyNum )
							{
								localStream.stop();	
							}							
						
					}
				
					
				currentStream.init(function(){
					currentStream.play('zoom_content_part');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						currentStream.play('zoom_content_part', function(errState){
						  currentStream.resume();
						});
					}
				});
			}
		else 
			{
				window['partZoomedIn'] = false;
				$('#zoomed_part').addClass('d-none');
				if ( !window['streamSwapped'] )
					{
						for( let i in cameraStreams )
							{
								cameraStreams[i].stop();
							}
					}
				
					
				currentStream.stop();
				currentStream.init(function(){
					currentStream.play('mystream');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						currentStream.play('mystream', function(errState){
						  currentStream.resume();
						});
					}
				});
				
			}			
	}
	
	function showPartStreamAfterDisabled(){
		cameraStreams[cameraIndex].init(function(){
					cameraStreams[cameraIndex].play('mystream');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						cameraStreams[cameraIndex].play('mystream', function(errState){
						  cameraStreams[cameraIndex].resume();
						});
					}
				});
	}
	
	window['showPartStreamAfterDisabled'] = showPartStreamAfterDisabled;
	
	function hideParticipantStreamWhenSwitch(){
		console.log('aaaaaaa--------');
	}
	
	window['hideParticipantStreamWhenSwitch'] = hideParticipantStreamWhenSwitch;
	
	function checkHideStreams(){
		if ( currentUserData.sessionData.showOtherParticipants == 1 )
			{
				for ( let i = 0; i<usersOnScreenCurrent.length; i++ )
					{
						if ( usersOnScreenCurrent[i] )
							{
								var userDetailsStream = collection.getDetailsById(usersOnScreenCurrent[i]);
								if ( userDetailsStream ) //&& userDetailsStream.broadcastVideo !== false
									{
										subscribeToVideoStream(userDetailsStream['id']);
									}
							}
					}
				$('#participants_streams').removeClass('d-none');
				window['showOtherParticipants'] = true;
			}
		else
			{
				for ( let i = 0; i<usersOnScreenCurrent.length; i++ )
					{
						if ( usersOnScreenCurrent[i] )
							{
								subscribeToAudioOnlyStream(usersOnScreenCurrent[i]);
							}
					}
				$('#participants_streams').addClass('d-none');
				window['showOtherParticipants'] = false;
			}
	}
	
	checkHideStreams();
	
	function setHostOffline() {
		if ( currentUserData.sessionData.ondemandId > 0 ) { return false; }
		
		$('#onlinetext').text('OFFLINE');
		$('#offlineicon').removeClass('d-none');
		$('#hostNoVideo').removeClass('d-none');
		$('#onlineicon').addClass('d-none');
		$('#record_info').addClass('d-none');
		$('#playlist_participant').addClass('d-none');
		
		currentUserData.sessionData.isHostOffline = 1;
		localStorage.setItem('userData', JSON.stringify(currentUserData));

		if ( window['streamSwapped'] )
			{
				swapStreamVirtual(true, true, true, 'pip', true);
			}
		
		rtm.invoke({'code': 504});
		window['checkActivityStop']();
		if ( window.stopFooterActivity ) { window.stopFooterActivity(); }
	}
	
	window['zoomParticipant'] = zoomParticipant;
	
	window.setPipStream=(par)=>{
		if ( window['electron'] && window['hasConeScript'] && (!window['userWhiteboard'][currentUserData.id] || (window['userWhiteboard'][currentUserData.id] && !window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured )) ) { return false; }
		var host_stream;
		if ( !window['streamSwapped'] )
			{
				streamArray.forEach((stream)=>{
					if ( stream.streamId == currentUserData.sessionData.hostId )
						{
							host_stream = stream;
						}
					})
			}
		else 
			{
				host_stream = localStream;
			}			
		if ( !host_stream ) 
			{ 
				checkForPipAgain(par);
				return false;
			}
		
		if ( par == 1 )
			{			
				window['injectedStarted'] = true;
				host_stream.stop();
				host_stream.init(function(){
					host_stream.play('injected_pip_video');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						host_stream.play('injected_pip_video', function(errState){
						  host_stream.resume();
						});
					}
				});
				
			}
		else 
			{
				window['injectedStarted'] = false;
				host_stream.stop();
				host_stream.init(function(){
					host_stream.play('host_stream');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						host_stream.play('host_stream', function(errState){
						  host_stream.resume();
						});
					}
				});
			}			
	}
	
	window.setShareAll=(par, userId)=>{
		console.log('window.setShareAll*************************');
		var user_stream;
		var injected_stream = localStream;
		var userStreamId;
		console.log(par, userId, window['streamSwapped'], 'setShareAll called');
		streamArray.forEach((stream)=>{
			if ( stream.streamId == userId )
				{
					user_stream = stream;
					userStreamId = stream.streamId;
				}
			if ( stream.streamId == currentUserData.sessionData.hostId && !window['streamSwapped'] )
				{
					injected_stream = stream;
				}
		});
					
		if ( !user_stream ) 
			{ 
				checkForShareAgain(par, userId);
				return false;
			}
		
		if ( par == 1 )
			{
				currentSharedUser = userId;
				subscribeToVideoStream(userId);
				
				if ( window['streamSwapped'] )
					{
						$('#sessionCanvas, #gridCanvas').addClass('d-none');
						$('#canvasWrap').addClass('pipHostVideo').removeClass('centerCanvas');
					}
				else
					{
						injected_stream.stop();
						injected_stream.init(function(){
							injected_stream.play('injected_pip_video');
						}, function (err) {
							if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
								injected_stream.play('injected_pip_video', function(errState){
								  injected_stream.resume();
								});
							}
						});
						
						$('#canvasWrap').addClass('d-none');
					}
				
				$('#participant_stream'+userId).addClass('d-none');
				if ( $('#nocam'+userId).hasClass('d-none') ) { $('#shareAllScreen'+userId).removeClass('d-none'); }
				user_stream.stop();
				user_stream.init(function(){
					user_stream.play('host_stream');
				}, function (err) {
					if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
						user_stream.play('host_stream', function(errState){
						  user_stream.resume();
						});
					}
				});
				
				$('#canvasUser').removeClass('d-none');
			}
		else 
			{
				let myStream = 'host_stream';
				currentSharedUser = 0;
				
				if ( window['streamSwapped'] ) 
					{ 
						$('#sessionCanvas, #gridCanvas').removeClass('d-none');
						$('#canvasWrap').removeClass('pipHostVideo').addClass('centerCanvas');
						//$('#canvasWrap').removeClass('d-none');
						//if ( window['gridOn'+currentUserData.id] ) { window['drawBoard'+currentUserData.id](); }
					}
				else
					{
						injected_stream.stop();
						injected_stream.init(function(){
							injected_stream.play(myStream);
						}, function (err) {
							if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
								injected_stream.play(myStream, function(errState){
								  injected_stream.resume();
								});
							}
						});
						
						window['canvasOn'] = false;
					}
				
				
				if ( $('#nocam'+userId).hasClass('d-none') ) 
					{
						$('#participant_stream'+userId).removeClass('d-none');
						user_stream.stop();
						user_stream.init(function(){
							user_stream.play('participant_stream'+userId);
						}, function (err) {
							if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
								user_stream.play('participant_stream'+userId, function(errState){
								  user_stream.resume();
								});
							}
						});
					}
				
				$('#shareAllScreen'+userId).addClass('d-none'); 
				$('#canvasUser').addClass('d-none');
				$('#canvasUser').html('');
			}			
	}

	function checkForShareAgain(mod, userId){
		setTimeout(function(){ 
				window.setShareAll(mod, userId);
			}, 1500);
	}
	
	function checkForPipAgain(mod){
		setTimeout(function(){ 
				window.setPipStream(mod);
			}, 1500);
	}
	
	function checkForMicCamPermission(){
		let text = RTMConst.CAMERA_MIC_PERMISSION + sep;
		text = text + (localStorage.getItem('cameraAccessAllowed') == "true" ? 1 : 0);
		text = text + sep + (localStorage.getItem('microphoneAccessAllowed') == "true" ? 1 : 0);
		sendMessage(currentUserData.sessionData.hostEmail, text);
	}
	
	function muteDuringMicTest(mod){
		let addObject = {};
		if ( mod == 'mute' )
			{
				localStream.muteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "unmute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOn", "msg": "Local mic turned on"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			}
		else 
			{
				localStream.unmuteAudio();
				addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "mute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOff", "msg": "Local mic turned off"}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);
			}			
	}
	
	window['muteDuringMicTest'] = muteDuringMicTest;
	
	window.muteSpeaker = () => {
      if ( currentUserData.unmuteAllEnabled === true ) 
      {
          muteParticipantAudio();
      }
      else
      {
          streamArray.forEach((stream)=>{
            if ( stream.getId() != undefined ) 
            {
                stream.muteAudio();
                return;
            }
          });
      }

      hostStreamMuted = true;
	}

	window.unmuteSpeaker = () => {
      if ( currentUserData.unmuteAllEnabled === true ) 
      {
          unmuteParticipantAudio();
      }
      else
      {
          streamArray.forEach((stream)=>{
            if ( stream.getId() != undefined )
            {
				stream.unmuteAudio();
            }
          });
      }

      hostStreamMuted = false;
	}
		  
	$(document).ready(function(){
		
		$(document).off('click', '#chose_camera');
		$(document).on('click', '#chose_camera', function(){
			
			let myStream = !window['streamSwapped'] ? 'mystream' : window['injectedStarted'] ? 'injected_pip_video' :'host_stream';
			
			var keyId = this.getAttribute("data-keyid");
			cameraKeyNum = keyId;
			localStream.stop();
			$('#chose_camera .drop_checked').remove();
			$(this).append('<div class="drop_checked"></div>');
			for( let i in cameraStreams ){
              cameraStreams[i].stop();
            }
			
			cameraStreams[keyId].init(function(){
				cameraStreams[keyId].play(myStream);
            }, function (err) {
			  if (err.msg == 'STREAM_ALREADY_INITIALIZED') {
				cameraStreams[keyId].play(myStream, function(errState){
                  cameraStreams[keyId].resume();
                });
              }
            });
		
			if ( cameraStreams[keyId] && cameraStreams[keyId]['streamObject'] && cameraStreams[keyId]['streamObject'].cameraId )
				{
					let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));	
					mediaSetting['camera'] = cameraStreams[keyId]['streamObject'].cameraId;
					localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
					
					if ( window['applyCameraRestrict'] ) { window['applyCameraRestrict'](); }
				}
			else if ( cameraStreams[keyId] && cameraStreams[keyId].cameraId )
				{
					let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));	
					mediaSetting['camera'] = cameraStreams[keyId].cameraId;
					localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
				}

			changeCameraStream();
		});
		
		$(document).off('click', '#chose_mic');
		$(document).on('click', '#chose_mic', function(){
			var keyId = this.getAttribute("data-keyid");
			
			$('#chose_mic .drop_checked').remove();
			$(this).append('<div class="drop_checked"></div>');
			
			let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));
			mediaSetting['microphone'] = keyId;
			window['main_mic_id_gue'] = keyId;
			localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
			
			swithMicAndSpeaker();
		});
		
		$(document).off('click', '#chose_speak');
		$(document).on('click', '#chose_speak', function(){
			var keyId = this.getAttribute("data-keyid");
			
			$('#chose_speak .drop_checked').remove();
			$(this).append('<div class="drop_checked"></div>');
			
			AgoraRTC.switchSpeaker(keyId);
			
			let mediaSetting = JSON.parse(localStorage.getItem(hostlanguage.mediaSetting));
			mediaSetting['speaker'] = keyId;
			localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaSetting));
		});
		
		$('#Like').bind("click", sendFitnessEmoji.bind(this, "like"));
		$('#Meh').bind("click", sendFitnessEmoji.bind(this, "dislike"));
		$('#Easy').bind("click", sendFitnessEmoji.bind(this, "easy"));
		$('#Ouch').bind("click", sendFitnessEmoji.bind(this, "too-hard"));
		$('#Beast').bind("click", sendFitnessEmoji.bind(this, "perfect"));
		$('#Cool').bind("click", sendFitnessEmoji.bind(this, "awesome"));
		
		$(document).off('click', '#mic_control');
		$(document).on('click', '#mic_control', function(){
			let addObject = {};
			if ( $('#microphone_control').text() == 'Mute Microphone' ) 
				{
					$('#microphone_control').text('Unmute Microphone');
					localStream.muteAudio();
					addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "unmute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOn", "msg": "Local mic turned on"}), "timestamp": Util.getCurrentTimestamp()};
					sessionDataStore.addSessionData(addObject);
					$('.audio_icon .muted_audio').removeClass('d-none');
					$('#mic_control .muted_audio').removeClass('d-none');
					isMutedByMe = true;
					window['isMutedByMe'] = true;
					
					let text = RTMConst.PARTICIPANT_MUTED_SELF + sep + currentUserData.id;
					sendMessage(currentUserData.sessionData.hostEmail, text);
				}
			else
				{
					$('#microphone_control').text('Mute Microphone');
					localStream.unmuteAudio();
					addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "mute", "userId": currentUserData.id, "details": JSON.stringify({"action": "micOff", "msg": "Local mic turned off"}), "timestamp": Util.getCurrentTimestamp()};
					sessionDataStore.addSessionData(addObject);
					$('.audio_icon .muted_audio').addClass('d-none');
					$('#mic_control .muted_audio').addClass('d-none');
					isMutedByMe = false;
					window['isMutedByMe'] = false;
					
					let text = RTMConst.PARTICIPANT_UNMUTED_SELF + sep + currentUserData.id;
					sendMessage(currentUserData.sessionData.hostEmail, text);
				}
		});
		
		$(document).off('click', '#speak_control');
		$(document).on('click', '#speak_control', function(){
			if ( $('#speaker_control').text() == 'Mute Speaker' ) 
				{
					$('#speaker_control').text('Unmute Speaker');
					$('#speak_control .muted_audio').removeClass('d-none');
					window.muteSpeaker();
				}
			else
				{
					$('#speaker_control').text('Mute Speaker');
					$('#speak_control .muted_audio').addClass('d-none');
					window.unmuteSpeaker();
				}
		});
		
		$(document).off('click', '#zoom_option');
		$(document).on('click', '#zoom_option', function(){
			if ( zoomedOption == 1 )
				{
					$('#host_stream').addClass('smaller_stream_host');
					$('#injected_video').addClass('smaller_stream_host');
					$('.stream_inner').addClass('stream_inner_zoomed');
					zoomedOption = 2;
					window['zoomedOption'] = 2;
					return false;
				}
				
			if ( zoomedOption == 2 )
				{
					$('.stream_inner').removeClass('stream_inner_zoomed');
					$('#host_stream').removeClass('smaller_stream_host');
					$('#injected_video').removeClass('smaller_stream_host');
					//$('.footer_streaming').addClass('d-none');
					$('.stream_container').addClass('d-none');
					$('.session_data_container').addClass('d-none');
					$('.participant_header').addClass('txt-center');
					zoomedOption = 3;
					window['zoomedOption'] = 3;
					return false;
				}
				
			if ( zoomedOption == 3 )
				{
					$('.footer_streaming').removeClass('d-none');
					let selfStreamTurnedOff = false;
					let turnOfCamera = [];
					if ( localStorage.getItem("turnOfCamera") )
						{
							turnOfCamera = JSON.parse(localStorage.getItem("turnOfCamera"));
						}
					
					if ( turnOfCamera && turnOfCamera.length > 0)
						{
							for (let i=0; i<turnOfCamera.length; i++)
								{
									if ( turnOfCamera[i] == "Me (I dont't want to see myself)" )
										{
											selfStreamTurnedOff = true;
										}
								}
						}
					$('.stream_container').removeClass('d-none');
					if ( selfStreamTurnedOff )
						{
							$('#mine_stream').addClass('d-none'); 
						}
					$('.session_data_container').removeClass('d-none');
					$('.participant_header').removeClass('txt-center');
					
					if ( window['showOtherParticipants'] )
						{
							$('#participants_streams').removeClass('d-none');
						}
					else 
						{
							$('#participants_streams').addClass('d-none');
						}						
					
					zoomedOption = 1;
					window['zoomedOption'] = 1;
					return false;
				}
		});

		$(document).off('click', '#my_view_part');
		$(document).on('click', '#my_view_part', function(){
			zoomParticipant(1);
		});
			
		$(document).off('click', '#zoom_out_part');
		$(document).on('click', '#zoom_out_part', function(){
			zoomParticipant(0);
		});

		if ( window['scriptLoaded'] && window['preStreamingWhite'] && window['userWhiteboard'][currentUserData.id] )
			{
				//window['resetPartWhiteboard']();
				window['preStreamingWhite'] = false;
				window['userWhiteboard'][currentUserData.id].loadElements();
				
				console.log('preStreamingRoomSetup viewCaptured');
				console.log(window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured);
				
				/* if ( window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured )
					{
						var message = 'preStreamingRoomSetup'+sep;
						window['userWhiteboard'][currentUserData.id].splitRTMSend(currentUserData.sessionData.hostEmail, message);
					} */
			}
	});

	window.handRaiseClient = () => {
		let handraiseCode = currentUserData.rtm.handRaise.code;
		let massage = handraiseCode+sep;
		sendMessage(currentUserData.sessionData.hostEmail, massage);

		let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.sessionData.hostId, "message": RTMConst.SEND_HANDRAISE, "details": JSON.stringify({"action":"handRaise","msg":"Hand Raise"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
	};
	
	function informVideoBroadcasting(status, mod?) {
	  ////console.log('informVideoBroadcasting***************************************');
      let message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
	  if ( mod )
		{
			message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status + sep + 1;
		}
      sendMessageToChannel(message);
	  
	  switchVideoBroadcastingHost(status, true);

	  let userDetails = collection.getDetailsById(currentUserData.id);
	  if ( userDetails )
		{
			let state = false;
			if ( status == 1 )
				{
					state = true;
				}
			let updateObject = {"broadcastVideo": state};
			collection.updateModel(userDetails.id, JSON.stringify(updateObject));
			addUserAttribute(userDetails.id, 'broadcastVideo', state);
		}

      let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.SWITCH_VIDEO_BROADCAST, "details": JSON.stringify({"action": "Inform About Video Broadcasting to Other Participants", "value": status}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
	}
	
	window.informVideoBroadcasting = informVideoBroadcasting;
	
	function switchVideoBroadcasting(status, mod?) {
      let message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
	  if (mod)
		{
			message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status + sep + 1;
		}
      sendMessageToChannel(message);

	  let userDetails = collection.getDetailsById(currentUserData.id);
	  if ( userDetails )
		{
			let state = false;
			if ( status == 1 )
				{
					state = true;
				}
			let updateObject = {"broadcastVideo": state};
			collection.updateModel(userDetails.id, JSON.stringify(updateObject));
			addUserAttribute(userDetails.id, 'broadcastVideo', state);
		}

      let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": "all", "message": RTMConst.SWITCH_VIDEO_BROADCAST, "details": JSON.stringify({"action": "Stop Video Broadcasting to Other Participants", "value": status}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
	}
	
	window.switchVideoBroadcasting = switchVideoBroadcasting;
	
	function switchVideoBroadcastingHost(status, mod?) {
      let message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status;
	  if ( mod )
		{
			message = RTMConst.SWITCH_VIDEO_BROADCAST + sep + status + sep + 1;
		}
      sendMessage(currentUserData.sessionData.hostEmail, message);
	  
	  let userDetails = collection.getDetailsById(currentUserData.id);
	  if ( userDetails )
		{
			let state = false;
			if ( status == 1 )
				{
					state = true;
				}
			let updateObject = {"broadcastVideoHost": state};
			collection.updateModel(userDetails.id, JSON.stringify(updateObject));
			addUserAttribute(userDetails.id, 'broadcastVideoHost', state);
		}

      let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.sessionData.hostId, "message": RTMConst.SWITCH_VIDEO_BROADCAST, "details": JSON.stringify({"action": "Stop Video Broadcasting to Host", "value": status}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
	}
	
	window.switchVideoBroadcastingHost = switchVideoBroadcastingHost;
	
	window.logout = () => {
      window['instructorMutedFm'] = false;
	  window['clickedOnLogout'] = true;
	  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "logout", "userId": currentUserData.id, "details": JSON.stringify({"status":"success", "action":"Logout"}), "timestamp": Util.getCurrentTimestamp()};

      sessionDataStore.addSessionData(addObject);
      sessionDataStore.dumpData();
      
      //clearInterval(switchRef);

      leave();
      leave_channel();
	}
	
	function swapStreamVirtual(mod, req?, type?, pip?, goNext?) {
		console.log('swapStreamVirtual*********************************');
		let seeMyselfOff = false;
		if ( localStorage.getItem('turnOfCamera') )
			{
				let cameraDisableStatus = JSON.parse(localStorage.getItem('turnOfCamera'));
				for ( var i = 0; i<cameraDisableStatus.length; i++ )
					{
						if ( cameraDisableStatus[i] == 'Me (I dont\'t want to see myself)' ) 
							{
								seeMyselfOff = true;
							}
					}
			}
		if ( !window['cameraFoundStatus'] || seeMyselfOff )
			{
				console.log('false swapStreamVirtual*********************************');
				window['canvasOn'] = false;
				return false;
			}
			
		window['streamSwapped'] = mod;
		if ( goNext )
			{
				returnMyStream();
				return false;
			}
		var stream1;
		streamArray.forEach((stream)=>{
			if ( stream.streamId == currentUserData.sessionData.hostId )
				{
					console.log('MATCH');
					stream1 = stream;
				}
		});
		if ( stream1 || currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 )
			{
				console.log('MATCH');
				$('#zoomed_part').addClass('d-none');
				let hostStream = window['streamSwapped'] ? 'host_stream' : 'hostmystream';
				let myStream = window['streamSwapped'] ? 'mystream' : 'host_stream';
				if ( pip == 'pip' ) 
					{ 
						hostStream = window['streamSwapped'] && !window['injectedStarted'] ? 'host_stream' : window['streamSwapped'] && window['injectedStarted'] ? 'injected_pip_video' : 'mystream';
						myStream = window['streamSwapped'] ? 'mystream' : window['injectedStarted'] ? 'injected_pip_video' :'host_stream';
					}
				let timeoutTime = window['streamSwapped'] ? 0 : 1000;
				
				console.log('hostStream');
				console.log(hostStream);
				console.log('myStream');
				console.log(myStream);
				
				if ( !window['streamSwapped'] )
					{
						if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 )
							{
								var host_stream2 = document.getElementById('hostmystream');
								var replayClassElement2 = document.getElementById('replayClassVideo');
								host_stream2.append(replayClassElement2);
							}
							
						if ( window['partZoomedIn'] ) { zoomParticipant(0) }
						window.$('#toolTipContainer').html('');
						window.$('#toolTipContainer').html('<span id="script_msg_par" class="screen_popup room_capturing_popup rounded tool_tip_inner tooltipText script_msg_inner bg-grayy rounded d-none"></span><span id="heightToolTip" class="screen_popup room_capturing_popup height_tip d-none"><div id="heightProgressBar"><div class="tooltipText rounded progress_bar_percent"><span id="progressHeightNum">0</span><span id="percentProgress">%</span></div><div id="heightProgress"></div></div><div class="heightTipText bg-grayy rounded stand_still_box">Stand still <span class="separate_stats">Capturing height</span></div></span><span id="partToolTip" class="room_capturing_popup bg-grayy rounded d-none"><span class="separate_stats tool_tip_inner"><div class="room_setup_loader d-none"><div class="room_setup_loader_inner"></div></div><span class="tooltipSuccess d-none"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 20 130 80" class="tooltipSvg d-none"><polyline id="v_shape" points="5 -10 50 60 80 60 125 -10" stroke="white" fill="transparent" stroke-width="20"/><defs><linearGradient id="progress"><stop id="stop1" offset="0" stop-color="rgb(32, 205, 243)"/><stop id="stop2" offset="0" stop-color="white"/></linearGradient></defs></svg><div class="tooltipImage"></div><div id="upNextText" class="up_next d-none"></div><div class="tooltipText rounded"></div><div id="innerPartText" class="part_inner"></div><div id="walkToolImage" class="walk_tool_hold d-none"><div class="walk_tool_image"></div><div class="walk_tool_text button_text"></div></div><div class="tooltipNumber d-none"></div></span><span id="progressBarRoom" class="separate_stats d-none"></span></span><div id="agora_remote'+currentUserData.id+'"><div class="hostCamBack d-none"></div><div id="agora_remote_vdo'+currentUserData.id+'" class="video-streams custom-video-streams"></div></div><div class="zoomFullScreen d-none" data-toggle="tooltip" title="Change View"></div>');
						if ( pip !== 'pip' )
							{
								$('#mystream').addClass('d-none');
								$('#hostmystream').removeClass('d-none');
							}			
					}
				else
					{
						if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 )
							{
								var host_stream2 = document.getElementById('host_stream');
								var replayClassElement2 = document.getElementById('replayClassVideo');
								host_stream2.append(replayClassElement2);
							}
							
						if ( pip !== 'pip' )
							{
								$('#mystream').removeClass('d-none');
								$('#hostmystream').addClass('d-none');
							}
					}
							
				if ( pip == 'pip' )
					{
						if ( stream1.isPlaying() ) 
							{
								stream1.stop();
							}
						
						if ( type )
							{
								for( let i in cameraStreams )
									{
										cameraStreams[i].stop();
									}
							}
						
						let currentStream = '';
						if ( !cameraKeyNum )
							{
								currentStream = localStream;
							}
						else 
							{
								let numKey = parseInt(cameraKeyNum);
								currentStream = cameraStreams[numKey];
							}	
						
						currentStream.stop();
						currentStream.play(myStream);
						 
						$('#hostNoVideo').addClass('d-none');
						stream1.play(hostStream, function(errState){
							if (errState && errState.status !== "aborted")
								{
									stream1.resume();
								}
						});
					}
				else if ( currentUserData.sessionData.replayClassId == 0 && !currentUserData.sessionData.ondemandId )
					{
						console.log('swapStreamVirtual 1');
						setTimeout(function() { 
							console.log('swapStreamVirtual 2');
							if ( stream1.isPlaying() ) 
								{
									console.log('swapStreamVirtual 3');
									stream1.stop();
									console.log('swapStreamVirtual 4');
								}
							if ( type )
								{
									console.log('swapStreamVirtual 5');
									for( let i in cameraStreams )
										{
											console.log('swapStreamVirtual 6');
										  cameraStreams[i].stop();
										  console.log('swapStreamVirtual 7');
										}
								}								
							
								$('#hostNoVideo').addClass('d-none');
								console.log('swapStreamVirtual 8');
								stream1.play(hostStream, function(errState){
									console.log('swapStreamVirtual 9');
									if (errState && errState.status !== "aborted")
										{
											console.log('swapStreamVirtual 10');
											stream1.resume();
											console.log('swapStreamVirtual 11');
										}
										console.log('swapStreamVirtual 12');
									if ( window['streamSwapped'] ) {console.log('swapStreamVirtual 13'); setTimeout(function() { console.log('swapStreamVirtual 14'); $('#imageCanvas').css("display", "none"); }, 1500);}console.log('swapStreamVirtual 15');
								});
								console.log('swapStreamVirtual 16');
						}, timeoutTime);
					}
				
				if ( !window['streamSwapped'] )
					{
						console.log('streamSwapped false');
						window.$('.footer_activity_container').removeClass('footer_active');

						//window.$('.footer_streaming').addClass('d-none');
						if ( pip !== 'pip' ) { window.$('#canvasWrap').removeClass('d-none'); }
						console.log('streamSwapped1');
						window.$('#my_view_part_me').addClass('d-none');
						if ( !type )
							{
								console.log('streamSwapped2');
								window.$('#showCameraOptions').addClass('d-none');
								window.$('#cameraDisableHold').removeClass('d-none');
								console.log('streamSwapped3');
							}
						console.log('streamSwapped4');
						
						if ( !window['userWhiteboard'][currentUserData.id] || (window['userWhiteboard'][currentUserData.id] && !window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured ) )
							{
								console.log('streamSwapped5');
								console.log(window['scriptLoaded']);
								if ( !window['scriptLoaded'] )
									{
										console.log('scriptLoaded');
										//loadWhiteboard();
										console.log(window['userWhiteboard']);
										console.log(window['userWhiteboard'][currentUserData.id]);
										window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id});
										console.log(window['userWhiteboard'][currentUserData.id]);
										window['scriptLoaded'] = true;
									}
								console.log('scriptLoaded22');
								console.log(window['userWhiteboard'][currentUserData.id].roomSetup, 'roomSetupFile before');
								if ( !req && !window.deviceNotSupported && !window['userCameraOff'] ) 
									{ 
										if ( !window['isDrawingStarted'] )
											{
												//window['userWhiteboard'][currentUserData.id].roomSetup.startRoomSetup(); 
												window.startRoomSetup();
											}
										else 
											{
												window['isDrawingStarted'] = false;
											}
									}
									
								console.log(window['userWhiteboard'][currentUserData.id].roomSetup, 'roomSetupFile after');
							}
						console.log('streamSwapped6');
						if ( window['hasConeScript'] && window['hasBoxJump'] ) { window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'sendBoxInfo'+sep+window['boxJumpSize']+sep+window['useEquipmentLocation']); }
						console.log('streamSwapped7');
						window['streamSwapped'] = true;
						window.$('#stream_user_name').html(currentUserData.sessionData.hostFirstName);
						window.$('#stream_user_name_host').html(currentUserData.sessionData.hostFirstName);
					}
				else 
					{
						console.log('streamSwapped true');
						if ( !window.pauseVirtualActivityStarted )
							{
								if ( window['closeDrawStatus'] )
									{
										window.$('#canvasWrap').addClass('d-none').removeClass('hostVirtualOnMember');
										window['closeDrawStatus'] = false;
									}
								else 
									{
										setTimeout(function() { 
											if ( !window.pauseVirtualActivityStarted )
												{ 
													window.$('#canvasWrap').addClass('d-none').removeClass('hostVirtualOnMember');
												}						
										}, 1500);
									}	
							}
									
						window.$('#partToolTip').addClass('d-none');
						window.$('.footer_streaming').removeClass('d-none');
						window.$('#showCameraOptions').removeClass('d-none');
						window.$('#cameraDisableHold').addClass('d-none');
						window.$('.footer_activity_container').addClass('footer_active');
						window.$('#partToolTip').addClass('d-none');
						window.$('#my_view_part_me').removeClass('d-none');
						window['canvasOn'] = false;
						if ( window['hasConeScript'] && window['userWhiteboard'][currentUserData.id] )
							{
								window['userWhiteboard'][currentUserData.id].resetCanvas();
								window.changeGlobalActType('', parseInt(currentUserData.id));
							}
						
						window.$('#stream_user_name').html('Me');
						window['streamSwapped'] = false;	
					}
			}
	}
	
	window.swapStreamVirtual = swapStreamVirtual;
	
	function returnMyStream(){
			let myStream = window['streamSwapped'] ? 'mystream' : window['injectedStarted'] ? 'injected_pip_video' :'host_stream';

			localStream.stop();
			localStream.play(myStream);
			 
			$('#hostNoVideo').addClass('d-none');
			
			setTimeout(function() { 
				if ( !window.pauseVirtualActivityStarted )
					{ 
						window.$('#canvasWrap').addClass('d-none').removeClass('hostVirtualOnMember');
					}						
			}, 1500);
					
			window.$('#partToolTip').addClass('d-none');
			window.$('.footer_streaming').removeClass('d-none');
			window.$('#showCameraOptions').removeClass('d-none');
			window.$('#cameraDisableHold').addClass('d-none');
			window.$('.footer_activity_container').addClass('footer_active');
			window.$('#partToolTip').addClass('d-none');
			window.$('#my_view_part_me').removeClass('d-none');
			window['canvasOn'] = false;
			if ( window['hasConeScript'] && window['userWhiteboard'][currentUserData.id] )
				{
					window['userWhiteboard'][currentUserData.id].resetCanvas();
				}
			
			window.$('#stream_user_name').html('Me');
			window['streamSwapped'] = false;
		}
	
	function changeBoxingPosition(pos,bag) {
		window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'changeBoxingPosition'+sep+pos+sep+bag+sep);
	}
	window.changeBoxingPosition = changeBoxingPosition;
	
	function checkActivityType(ind) {
		
		var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
		
		for ( let i = 0; i < workoutArray.length; i++ )
			{
				if ( workoutArray[i]['attribute'][0]['attrValue'] == 'Pause' || workoutArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
					{
						workoutArray.splice(i, 1);
						i--;
					}
			}
		
		if ( !workoutArray || !workoutArray[ind] || !workoutArray[ind]['attribute'] || !workoutArray[ind]['attribute'][0] || !workoutArray[ind]['attribute'][0]['attrValue'] ) { return ''; }
		return workoutArray[ind]['attribute'][0]['attrValue'];
	}
	window.checkActivityType = checkActivityType;
	
	function canvasScale(startRoomSetup) {
		let scaleW = $('#sessionCanvas')[0].width / window['hostCanvasSize']['w'];
		let scaleH = $('#sessionCanvas')[0].height / window['hostCanvasSize']['h'];
		//console.log('WIDTH DIFFERENCE', scaleW, '  ', scaleH);
		
		window['scaleW'] = scaleW;
		window['scaleH'] = scaleH;
		
		//window['pixelsPerMm'](scaleH);
		
		window['playBagAnimation'] = false;
		
		let linesPt = window['linesPt'];
		
		
		linesPt.forEach(function(item) {
			if ( item['stPoint'] )
				{
					item['stPoint'].x = item['stPoint'].x * scaleW;
					item['stPoint'].y = item['stPoint'].y * scaleH;
					item['endPoint'].x = item['endPoint'].x * scaleW;
					item['endPoint'].y = item['endPoint'].y * scaleH;
				}
			else if ( item['t'] == 'ladder' || item['t'] == 'cone' || item['t'] == 'box' || item['t'] == 'hurdle' || item['t'] == 'bag' || item['t'] == 'ball' || item['t'] == 'r' || item['t'] == 'squat' || item['t'] == 'cone_diagonal' )
				{
					item.startX = item.startX * scaleW;
					item.startY = item.startY * scaleH;
					item.w = item.w * scaleW; 
					item.h = item.h * scaleH;
					
					if ( item['t'] == 'bag' && item['animation'] ) 
						{ 
							window['playBagAnimation'] = true; 
							if ( item['startX'] < 0 || item['startX'] > 1280 )
								{
									window['didAnimationBag'+currentUserData.id] = false;
								}
						}
					
					if ( item['t'] != 'r' )
						{
							window['hasEquipment'+currentUserData.id] = true;
						}
				}
			else if ( item['t'] == 'c' )
				{
					item['x1'] = item['x1'] * scaleW; 
					item['y1'] = item['y1'] * scaleH; 
					item['x2'] = item['x2'] * scaleW; 
					item['y2'] = item['y2'] * scaleH;
					
					if ( item['heightC'] )
						{
							window['userWhiteboard'][currentUserData.id].workoutCirclePosition = item;
						}
				}
			else if ( item['t'] == 'a' )
				{
					item['stX'] = item['stX'] * scaleW; 
					item['stY'] = item['stY'] * scaleH; 
					item['x1'] = item['x1'] * scaleW; 
					item['y1'] = item['y1'] * scaleH; 
					item['x2'] = item['x2'] * scaleW; 
					item['y2'] = item['y2'] * scaleH;
				}
			else
				{
					if ( item.forEach )
						{
							item.forEach(function(item2, index) {
								if ( item2['x1'] )
									{
										if ( index > 0 )
											{
												item2['x1'] = item2['x1'] * scaleW;
												item2['y1'] = item2['y1'] * scaleH;
												item2['x2'] = item2['x2'] * scaleW; 
												item2['y2'] = item2['y2'] * scaleH;
											}
									}
								else
									{
										item2['x'] = item2['x'] * scaleW;
										item2['y'] = item2['y'] * scaleH;
									}
							});
						}
				}
		});
		console.log('linesPt', linesPt);
		if ( window['userWhiteboard'][currentUserData.id] )
			{
				window['userWhiteboard'][currentUserData.id].updateLines(linesPt);
				
				setTimeout(function(){
					window['userWhiteboard'][currentUserData.id].drawLines();
				}, 500);
			}
	
		if ( linesPt.length == 0 && !startRoomSetup )
			{
				window['repCounting'] = 0;		
				window.$('#repcounter').html(window['repCounting']);				
				$('#repcounter').html(window['repCounting']);
			}
	}
	window.canvasScale = canvasScale;
	
	function pauseBeforeEquipment(mod, type, name) {
		//console.log(mod, 'PAUSE ACTIVITY');
		
		window['playedMoveSound'] = false;
		window['playOutsideOnce'] = true;
		var script_name_participant = window.currentUserData.sessionData.scriptDetail[window['globalCurrentIndex']]['name'];
		
		let activeEle = $('.swiper-slide.swiper-slide-next');
		var countdownNumberEl = activeEle.find('.countdown-number');
		var countDownNumInt = parseInt(countdownNumberEl.text());
		if ( countDownNumInt < 2 )
			{
				window['pauseBeforeEquipmentInjected'] = true;
			}
				
		if ( mod === 'true' )
			{
				if ( window['deviceNotSupported'] || window['userCameraOff'] ) { return false; }
				
				if ( !window['viewCaptured'+currentUserData.id] )
					{
						//$('#script_msg_par').html('Your next activity is '+type+' based.  Take a short break until '+name+' gives you get further instructions.');
						//$('#script_msg_par').removeClass('d-none');
						$('#partToolTip .tooltipImage').addClass('d-none');
						$('.walk_tool_image').css('background-image', 'url(images/eq_clock.png)');
						$('#partToolTip').removeClass('d-none');

						if ( currentUserData.sessionData.turnoffRoomSetup != undefined && currentUserData.sessionData.turnoffRoomSetup == 0 )
							{
								$('#walkToolImage').removeClass('d-none').addClass('center-pointer');
							}
						
						$('#walkToolImage .walk_tool_image').addClass('d-none');
						$('#upNextText').removeClass('d-none');
						$('#upNextText').html('UP NEXT:');
						$('.walk_tool_text').html('Start Room Setup');
						
						
						$('#walkToolImage').off('click');
						$('#walkToolImage').on('click', function(){
							
							window['roomSetupButton'] = true;
							
							sendMessage(currentUserData.sessionData.hostEmail, 'roomSetupButton'+sep);
							
							$('#canvasWrap').removeClass('d-none');
							if ( !window['scriptLoaded'] )
								{
									//loadWhiteboard();
									window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id});
								}
							
							window['scriptLoaded'] = true;
							
							if ( !window['canvasOn'] )
								{
									if ( !window['streamSwapped'] && !window['deviceNotSupported'] && !window['userCameraOff'] ) { swapStreamVirtual(false); }
								}
							
							window['canvasOn'] = true;
							
							$('#partToolTip').addClass('d-none');
							window.soundPlay.stopAudio();
							setTimeout(function ()
							{
								window['takeRoomSetup'+currentUserData.id]();
							}, 1000);
						});
						
						$('#partToolTip .tooltipText').html('Virtual Equipment');
						$('#partToolTip .part_inner').html('Time to get the room setup!');
						
						if ( currentUserData.sessionData.turnoffRoomSetup !== undefined && currentUserData.sessionData.turnoffRoomSetup == 1 )
							{
								var playParRoom = window['audioType'] == 'longAudio' ? 'startRoomSetupPartLongHost' : 'startRoomSetupPartHost';
								if ( window['audioType'] !== 'offAudio' ) { window.soundPlay.playAudio(playParRoom); }
							}
						else
							{
								var playParRoom = window['audioType'] == 'longAudio' ? 'startRoomSetupPartLong' : 'startRoomSetupPart';
								if ( window['audioType'] !== 'offAudio' ) { window.soundPlay.playAudio(playParRoom); }
							}
					}
			}
		else
			{
				$('#script_msg_par').html('');
				$('#script_msg_par').addClass('d-none');
				
				$('.walk_tool_image').css('background-image', 'none');
				$('#partToolTip').addClass('d-none');
				$('#walkToolImage').addClass('d-none');
				$('#walkToolImage .walk_tool_image').removeClass('d-none');
				$('#upNextText').addClass('d-none');
				$('#upNextText').html('');
				$('.walk_tool_text').html('');
				$('#partToolTip .tooltipText').html('');
				$('#partToolTip .part_inner').html('');
				
				$('.walk_tool_text').off('click');
			}
	}
	
	function highlightParticipant(parId) {
		let showParticipant = parId;
		console.log(showParticipant, 'showParticipant');
		console.log(currentUserData.id , 'showParticipantcurrentUserData.id ');
		if( showParticipant != currentUserData.id )
			{
				window['highlightActive'] = true;
				window['highlightedUser'] = parId;
			}
	}
	
	function removeHighlight(hostId, parId) {
		if( parId != currentUserData.id )
			{
				console.log(hostId, 'hostIdMain');
				console.log(parId, 'hostIdMain');
				window['highlightActive'] = false;
				window['highlightedUser'] = 0;
				window['shareAllStarted'] = false;
				window.setShareAll(0, parId);
				window['canvasLines'+currentUserData.id] = window['canvasLinesBackup'+currentUserData.id];
				if ( window['streamSwapped'] && !window['canvasOn'] ) { swapStreamVirtual(true, true, true, false, false); }
				window['reverseHighlight']();
			}
	}
	
	function checkDeviceForVirtual() {
	 if ( window['isFoundParEquipment'] && (!window['electron'] || android || ipad13) )
			{
				window['deviceNotSupported'] = true;
				$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none');
				var userId = JSON.parse(localStorage.getItem('userData')).id;
				setTimeout(function(){ window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'showVirtualError'+sep); }, 3000);
			}
		else
			{
				$('#virtualmsg').addClass('d-none');
				setTimeout(function(){ window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'hideVirtualError'+sep); }, 3000);
			} 
	}
	window.checkDeviceForVirtual = checkDeviceForVirtual;
	
	function pauseActivity(index) {
		let act_type = window['checkActivityType'](index);
		var activityLength = currentUserData.sessionData.scriptDetail.length;
		var playAllDone = false;
		var virtualType;
		window['activityEnded'] = true;
		for(var a = 0; a<activityLength; a++)
			{
				virtualType = window['checkActivityType'](a);
				if ( virtualType == 'Virtual Equipment' || virtualType == 'Virtual Assistant' )
					{
						playAllDone = a;
					}
			}
			
		if ( !window['deviceNotSupported'] && !window['userCameraOff'] ) { window['changeCountdown'] = true; }
		
		if ( window['scriptLoaded'] && (act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant') && !window['deviceNotSupported'] && !window['userCameraOff'] )
			{
				if ( playAllDone == index ) 
					{
						window['allDoneSound']();
						window['showMessageInstruction'](window['globalEquipmentObject'+currentUserData.id]['allDoneMessage'], false);
						setTimeout(function(){
							$('#partToolTip .tooltipText').html('');
							$('#partToolTip').addClass('d-none');
						}, 3000);
					}
				else if ( window['soundPlay'] )
					{
						window['soundPlay'].playAudio(window['globalEquipmentObject'+currentUserData.id][window['globalActType']]['audioEquipmentEnd']);
					}
			}
	}
	
	window.subscribeVisibleForVideo = () => {
		if ( usersOnScreenCurrent && usersOnScreenCurrent.length > 0 )
			{
				for ( let i=0; i<usersOnScreenCurrent.length; i++ )
					{
						let userDetails = collection.getDetailsById(usersOnScreenCurrent[i]);
						if ( userDetails && userDetails.broadcastVideo !== false )
							{
								subscribeToVideoStream(usersOnScreenCurrent[i]);
							}
						else
							{
								if ( userDetails.id !== currentSharedUser )
									{
										$('#participant_stream'+userDetails.id).addClass('d-none');
										$('#nocam'+userDetails.id).removeClass('d-none');
									}
							}
					}
				checkForInterval();
			}
	}
	
	window.subscribeVisibleForAudio = () => {
		console.log('----------------------');
		console.log(window['shareAllStarted']);
		console.log(currentSharedUser);
		if ( usersOnScreenCurrent && usersOnScreenCurrent.length > 0 )
			{
				for ( let i=0; i<usersOnScreenCurrent.length; i++ )
					{
						subscribeToAudioOnlyStream(usersOnScreenCurrent[i]);
						let userDetails = collection.getDetailsById(usersOnScreenCurrent[i]);
						if ( userDetails.broadcastVideo == false )
							{
								$('#participant_stream'+userDetails.id).addClass('d-none');
								$('#nocam'+userDetails.id).removeClass('d-none');
							}
					}
				//usersOnScreen = [];
				//clearInterval(window['switchStreamsInterval']);
				//window['switchStreamsInterval'] = null;
			}
	}
	
	window['sendBoxInfo'] = function() {
		if ( window['hasConeScript'] ) { window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'sendBoxInfo'+sep+window['boxJumpSize']+sep+window['useEquipmentLocation']); }
	}
	window['getSessionNotes'] = function() {
		
		var hostId = currentUserData['sessionData']['hostId'];
		var partId = currentUserData['id'];
		var sessionId = currentUserData['sessionData']['id'];
		
		var sessionData = {
				hostId : hostId,
				partId : partId,
				sessionId: sessionId
		};
		
		let fmsNotesArray = [];
		
		var data_op = JSON.parse(localStorage.getItem("userData"));
		$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
		  url: Const.BASE_API_PATH +'/api/v1/session/'+sessionId+'/getSessionNotes',
		  type: 'post',
		  dataType: 'json',
		  data: JSON.stringify(sessionData),
		  success: function( data, textStatus, jQxhr )
		  {
			if ( data.responseData )
				{
					var notesArr = data.responseData;
					if ( notesArr.length > 0 )
						{
							let fmsNum = notesArr.length;
							$('#fms_control').removeClass('d-none');
							$('#fms_images').html(fmsNum);
							
							for ( var i = 0; i < notesArr.length; i++ )
								{
									fmsNotesArray.push(notesArr[i]);
								}
						}
					else 
						{
							$('#fms_control').addClass('d-none');
						}						
					window['fmsNotes'] = fmsNotesArray;
				}
		  }});
	}

	setTimeout(function(){ window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'checkSessionStation'+sep); }, 3000);

	function checkTimeLeft(ind) {
		
		var workoutArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
		
		for ( let i = 0; i < workoutArray.length; i++ )
			{
				if ( workoutArray[i]['attribute'][0]['attrValue'] == 'Pause' || workoutArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
					{
						workoutArray.splice(i, 1);
						i--;
					}
			}
		
		if ( !workoutArray || !workoutArray[ind] || !workoutArray[ind]['attribute'] || !workoutArray[ind]['attribute'][2] || !workoutArray[ind]['attribute'][2]['attrValue'] ) { return ''; }
		return workoutArray[ind]['attribute'][2]['attrValue'];
	}
	window.checkTimeLeft = checkTimeLeft;
	/*const sendDebounced_REMOTE_VOLUME_CHANGE_FOR_INSTRUCTOR = debounce((volume) => {
		sendMessage(`RM-${peer}`, `${RTMConst.REMOTE_VOLUME_CHANGE_FOR_INSTRUCTOR}${sep}${volume}`);
	}, 1000)*/

	window['reduceHostVolume'] = function(volume) {

		//sendDebounced_REMOTE_VOLUME_CHANGE_FOR_INSTRUCTOR(volume);
		var hostId = JSON.parse(localStorage.getItem('userData')).sessionData.hostId;
		
		for ( var i = 0; i < streamArray.length; i++ )
			{
				var stream = streamArray[i];
				if ( stream.getId() == hostId ) 
					{ 
						if ( window['electron'] )
							{
								stream.changeStreamVolume(volume);
							}
						else
							{
								stream.setAudioVolume(volume); 
							}
					}
			}
	}
	
	window['playScriptSound'] = function(mod){
		if ( mod )
			{
				window['soundPlay'].playAudio(mod); 
			}
		
	}

	function removeWhiteboard() {
	  if ( window['userWhiteboard'] )
		{
			for ( var userId of Object.keys(window['userWhiteboard']) ) 
				{
					if ( window['userWhiteboard'][userId] )
						{
							clearInterval(window['userWhiteboard'][userId].updateInterval);
							if ( window['userWhiteboard'][userId].perMinuteInterval ) { clearInterval(window['userWhiteboard'][userId].perMinuteInterval); }
							window['changeGlobalCounter'] = undefined;
							window['calculatePerMinuteCounter'] = undefined;
							
							window['userWhiteboard'][currentUserData.id].soundPlay.stopAudio();
							
							window.removeUserWhiteboard(parseInt(userId));
						}
				}
				
			window.pauseVirtualActivityStarted = false;
			
			window['userWhiteboard'] = {};
		}
	}
	
	window.removeWhiteboard = removeWhiteboard;

	function startPauseActivity(script_name) {
		if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] )
			{
				if ( !window['streamSwapped'] )
					{
						swapStreamVirtual(false);
					}
					
				window.pauseVirtualActivityStarted = false;
				
				$('#canvasWrap').removeClass('hostVirtualOnMember');
				
				if ( window['userWhiteboard'][currentUserData.id].trackerActions.turnOffMediaPipe ) 
					{ 
						setTimeout(function() { window['userWhiteboard'][currentUserData.id].trackerActions.toggleMediaPipe(false); }, 1000);
					}
				
				window['userWhiteboard'][currentUserData.id].activityStarted(script_name);
				window['userWhiteboard'][currentUserData.id].currentActivityName = script_name;
				
				if ( window.detectionDisabled )
					{
						$('.virtualDisabledMsg').removeClass('d-none');
					}
				
				if ( window['deviceNotSupported'+currentUserData.id] )
					{
						$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none');
					}
			}
	}
	
	function startPauseVirtualActivity(script_name) {
		if ( !window['electron'] ) { return false; }
		if ( window['streamSwapped'] )
			{
				swapStreamVirtual(true);
			}
		
		window['updateStateFromChild']({openMyStream: false});
		if ( !window['showAllElementsStatus'] )
			{
				$('#mine_stream').addClass('opacityHide');
			}
		
		var hostWhiteboardId = currentUserData.sessionData.hostId != currentUserData.id ? currentUserData.sessionData.hostId : parseInt(JSON.stringify(currentUserData.sessionData.hostId)+'1000');
		window.hostWhiteboardId = hostWhiteboardId;
		
		if ( !window['userWhiteboard'][hostWhiteboardId] )
			{
				if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 ) { window['userWhiteboard'][hostWhiteboardId] = new whiteboard({'user_id': hostWhiteboardId, 'host_virtual_replay': true}); window['load'+hostWhiteboardId] = true; }
				else { window['userWhiteboard'][currentUserData.sessionData.hostId] = new whiteboard({'user_id': currentUserData.sessionData.hostId, 'host_virtual_member': true}); window['load'+currentUserData.sessionData.hostId] = true; }
			}
		
		window.changeGlobalActType('', currentUserData.id);
		
		window.pauseVirtualActivityStarted = true;
		
		console.log('pauseVirtualActivityStarted 111');
		console.log('pauseVirtualActivityStarted script_name');
		console.log(script_name);
		
		window.setPauseVirtualActName(script_name);
		
		window['userWhiteboard'][hostWhiteboardId].currentActivityName = script_name;
		
		if ( window['preStreamingRoomSetup'+hostWhiteboardId] && !window['userWhiteboard'][hostWhiteboardId].roomSetup.workoutAreaSetupDone )
			{
				console.log('preStreamingWASLocation', window['preStreamingWASLocation'+hostWhiteboardId]);
				console.log('loadPreWhiteboard 444');
				console.log('loadPreWhiteboard 777');
				window['userWhiteboard'][hostWhiteboardId].roomSetup.finishWorkoutSetupHost(window['preStreamingWASLocation'+hostWhiteboardId]);
				console.log('loadPreWhiteboard 888');
			}
			
		var workoutZone = {};
		if ( window['preStreamingWASLocation'+hostWhiteboardId] && !hostZoneSet )
			{
				let gridZoneObj = {
					'x1': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['topRight']['posX']),
					'x2': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['topLeft']['posX']),
					'x3': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['bottomRight']['posX']),
					'x4': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['bottomLeft']['posX']),
					'y1': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['topRight']['posY']),
					'y2': parseInt(window['preStreamingWASLocation'+hostWhiteboardId]['bottomRight']['posY']),
					'columns': 5,
					'rows': 3
				};
				console.log('pauseVirtualActivityStarted gridZoneObj', gridZoneObj);
				if ( window.gridZoneUpdate ) { console.log('pauseVirtualActivityStarted gridZoneUpdate'); window.gridZoneUpdate(JSON.stringify(gridZoneObj), parseInt(hostWhiteboardId)); hostZoneSet = true; }
			}	
		
		window['userWhiteboard'][hostWhiteboardId].activityStarted(script_name);
		
		$('#canvasWrap').addClass('hostVirtualOnMember').removeClass('d-none');
		$('#participant_activity').removeClass('d-none');
		$('#time_counter').removeClass('d-none');
		
		console.log('pauseVirtualActivityStarted 222');
		console.log('pauseVirtualActivityStarted 333');
	}

	if ( currentUserData && currentUserData.sessionData && currentUserData.sessionData.hostEmail && currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1)
		{
			let sep = '~@$';
			window['memberState'] = 'joinSession';
			let msg = RTMConst.MEMBER_ONLINE+sep+window['memberState']+sep+currentUserData.id;
			sendMessage(currentUserData.sessionData.hostEmail, msg);
		}
		
	let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "joinClass", "userId": currentUserData.id, "details": JSON.stringify({"msg": "User entered session"}), "timestamp": Util.getCurrentTimestamp()};
	sessionDataStore.addSessionData(addObject);
}

export default StreamingController;